import { updatePmSiteState } from "../redux/maintenance/pmList/action";
import {
  getHotoAssigneeList,
  renewalSaveData,
} from "../redux/brandActivtion/sitesListing/action";
import {
  approveHoldRequest,
  approveVendor,
} from "../redux/sales/vendorPortal/action";
import { fetchHotoEngList } from "../redux/maintenance/hoto/action";
import contractRenewal from "pages/brandActivation/contractRenewal";
import performanceTracker from "pages/sales/performanceTracker";

const baseUrl = `${process.env.REACT_APP_API_URL}`;
const vehicleBaseUrl = `${process.env.REACT_APP_VEHICLE_APP_URL}`;
const trimBase = (value) =>
  typeof value === 'string' ? value.trim().replace(/\/+$/, '') : '';

// Dockerfile sets REACT_APP_RECON_BASE_URL per APP_ENV. When that var is missing
// from the running bundle, derive the same host from the other environment URLs
// so the request never falls back to the frontend origin.
const reconHostForEnvironment = () => {
  const hints = [
    process.env.REACT_APP_API_URL,
    process.env.REACT_APP_FUSION_SERVICE_URL,
    process.env.REACT_APP_GO_API_URL,
    process.env.PUBLIC_URL,
  ]
    .filter((value) => typeof value === 'string')
    .join(' ')
    .toLowerCase();

  const isNonProd =
    hints.includes('sandbox') ||
    hints.includes('-stg') ||
    hints.includes('staging') ||
    hints.includes('127.0.0.1') ||
    hints.includes('localhost');

  return isNonProd
    ? 'https://recon-stg.parkplus.io/api'
    : 'https://recon-service.parkplus.io/api';
};

const configuredReconBase = trimBase(process.env.REACT_APP_RECON_BASE_URL);
const reconApiBase = /\/api$/i.test(configuredReconBase)
  ? configuredReconBase
  : configuredReconBase
    ? `${configuredReconBase}/api`
    : reconHostForEnvironment();
const storageUrl =
  typeof process.env.REACT_APP_STORAGE_SERVICE_URL === 'string' &&
  process.env.REACT_APP_STORAGE_SERVICE_URL.trim() !== ''
    ? process.env.REACT_APP_STORAGE_SERVICE_URL.trim()
    : 'https://storage.parkplus.io';
const fasTagUrl = `${process.env.REACT_APP_FASTAG_API_URL}`;
const fusionServiceUrl =
  typeof process.env.REACT_APP_FUSION_SERVICE_URL === 'string' &&
  process.env.REACT_APP_FUSION_SERVICE_URL.trim() !== ''
    ? process.env.REACT_APP_FUSION_SERVICE_URL.trim()
    : baseUrl;
const fusionBackendGoUrl =
  typeof process.env.REACT_APP_FUSION_BACKEND_GO_URL === 'string' &&
  process.env.REACT_APP_FUSION_BACKEND_GO_URL.trim() !== ''
    ? process.env.REACT_APP_FUSION_BACKEND_GO_URL.trim()
    : baseUrl;
const valetApiUrl =
  typeof process.env.REACT_APP_VALET_API_URL === 'string' &&
  process.env.REACT_APP_VALET_API_URL.trim() !== ''
    ? process.env.REACT_APP_VALET_API_URL.trim()
    : 'https://parkplus-valet-uat.parkplus.io';
const userServiceUrl =
  typeof process.env.REACT_APP_USER_SERVICE_URL === 'string' &&
  process.env.REACT_APP_USER_SERVICE_URL.trim() !== ''
    ? process.env.REACT_APP_USER_SERVICE_URL.trim()
    : 'https://user-service.parkplus.io';
const siteLeadReferralApiPath = '/api/v1/b2c/fusion-dashboard/referral';

// Base URL for APIs migrated to fusion-backend-go (Go service). Falls back to
// baseUrl (Laravel) when REACT_APP_GO_API_URL is not set, so nothing breaks if
// the Go host is unconfigured. To migrate an endpoint, switch its URL below from
// `${baseUrl}/...` to `${goBaseUrl}/...` (the /api/v1/... path stays the same).
const goBaseUrl =
  typeof process.env.REACT_APP_GO_API_URL === 'string' &&
  process.env.REACT_APP_GO_API_URL.trim() !== ''
    ? process.env.REACT_APP_GO_API_URL.trim()
    : baseUrl;

const Config = {
  loginApiUrl: {
    emailPhoneLogin: `${goBaseUrl}/api/v1/login`,
    loginOtp: `${goBaseUrl}/api/v1/generateOTP`,
    googleUserLogin: `${goBaseUrl}/api/v1/googleLogin`,
    refreshLogin: `${goBaseUrl}/api/v1/retry-login`,
  },
  profileUrl: {
    profile: `${goBaseUrl}/api/v1/getProfile`,
    getDashboardCount: `${baseUrl}/api/v1/getUserDashboardCount`,
    saveLocation: `${baseUrl}/api/v1/saveLocation`,
    userById: `${baseUrl}/api/v1/get-user`,
  },
  LeadDetails: {
    source: `${baseUrl}/api/v1/sales/lead/source`,
  },
  importLead: `${baseUrl}/api/v1/sales/lead/import`,
  uploadFlat: `${baseUrl}/api/v1/brandactivation/site/upload/flat/csv`,
  cxOrderRefundList: `${baseUrl}/api/v1/cx/refund-order`,
  cxOrderData: `${baseUrl}/api/v1/cx/refund-request-order`,
  refundApproval: `${baseUrl}/api/v1/cx/refund-request-approve`,
  pocDetials: {
    type: `${goBaseUrl}/api/v1/sales/lead/pocSiteTypes`,
    siteType: `${goBaseUrl}/api/v1/sales/lead/pocSiteTypes?is_supply=`,
    addClient: `${goBaseUrl}/api/v1/sales/lead/addClient`,
    getAllClients: `${goBaseUrl}/api/v1/sales/lead/getAllClients`,
    getAddressClient: `${goBaseUrl}/api/v1/sales/lead/getAddressClient`,
    setAddressClient: `${goBaseUrl}/api/v1/sales/lead/setAddressClient`,
    getClientBusinessDetails: `${goBaseUrl}/api/v1/sales/lead/getClientBusinessDetails`,
    getAddressBusiness: `${goBaseUrl}/api/v1/sales/lead/getAddressBusiness`,
    setAddressBusiness: `${goBaseUrl}/api/v1/sales/lead/setAddressBusiness`,
  },
  categoryDetials: {
    lead: `${goBaseUrl}/api/v1/sales/lead/categories`,
    supplyName: `${goBaseUrl}/api/v1/sales/lead/supplyList`,
    rwaTenure: `${goBaseUrl}/api/v1/sales/lead/rwaTenure`,
    supplyDropDown: `${goBaseUrl}/api/v1/sales/lead/createData/supply`,
    corporateDropDown: `${goBaseUrl}/api/v1/sales/lead/createData/corporate`,
    appartmentDropDown: `${goBaseUrl}/api/v1/sales/lead/createData/apartment`,
    sampleDownload: `${baseUrl}/api/v1/sales/lead/downloadImportSample`,
    supplyPocDropDown: `${goBaseUrl}/api/v1/sales/lead/createData/supplyPoc`,
  },
  preSalesList: {
    type: `${baseUrl}/api/v1/sales/lead/listCorporate`,
    listApartments: `${goBaseUrl}/api/v1/sales/lead/listApartments`,
    fetchAllData: `${goBaseUrl}/api/v1/sales/lead/fetchAllData`,
    listAlliance: `${goBaseUrl}/api/v1/sales/lead/listAlliance`,
    listSupply: `${goBaseUrl}/api/v1/sales/lead/listSupply`,
    status: `${goBaseUrl}/api/v1/sales/lead/statusList`,
    dealStatus: `${goBaseUrl}/api/v1/sales/lead/dealStatusList`,
    updateStatus: `${goBaseUrl}/api/v1/sales/lead/status/update`,
    assignes: `${goBaseUrl}/api/v1/sales/lead/assignees`,
    bulkAssignment: `${baseUrl}/api/v1/sales/lead/bulk/assignment`,
    approvalList: `${goBaseUrl}/api/v1/sales/lead/list`,
    financeContractList: `${baseUrl}/api/v1/sales/lead/financelist`,
    getSites: `${goBaseUrl}/api/v1/site/get-sites`,
    getSiteDetail: `${goBaseUrl}/api/v1/site/get-site-detail`,
    exportSitesCsv: `${goBaseUrl}/api/v1/site/export-sites-csv`,
    contractList: `${goBaseUrl}/api/v1/sales/lead/contractList`,
    approvalContractList: `${baseUrl}/api/v1/sales/lead/approvalContractList`,
    approvalAllContractList: `${goBaseUrl}/api/v1/sales/lead/all-contract-approval-list`,
    approvalContractAptList: `${baseUrl}/api/v1/sales/lead/approvalContractAptList`,
    approvalContractAptAllList: `${goBaseUrl}/api/v1/sales/lead/approvalContractAptAllList`,
    approvalContractSupplyList: `${goBaseUrl}/api/v1/sales/lead/approvalContractSupplyList`,
    inspectionApprovalContractList: `${goBaseUrl}/api/v1/sales/lead/inspectionApprovalContractList`,
    inspectionApprovalAptContractList: `${goBaseUrl}/api/v1/sales/lead/inspectionApprovalAptContractList`,
    inspectionApprovalDetails: `${goBaseUrl}/api/v1/sales/lead/inspectionApprovalDetails`,
    inspectionPostSolution: `${goBaseUrl}/api/v1/sales/lead/inspectionPostSolution`,
    inspectionReject: `${goBaseUrl}/api/v1/sales/lead/inspectionReject`,
    getSolutionQuestion: `${goBaseUrl}/api/v1/sales/lead/getSolutionQuestion`,
    paymentBusiness: `${baseUrl}/api/v1/sales/businessList`,
    paymentRequest: `${baseUrl}/api/v1/sales/requestList`,
    performaInvoiceListing: `${baseUrl}/api/v1/sales/performaInvoiceListing`,
    taxInvoiceListing: `${baseUrl}/api/v1/sales/taxInvoiceListing`,
    addAdvance: `${baseUrl}/api/v1/sales/saveAdvanceRequest`,
    addAdvanceUnclaim: `${baseUrl}/api/v1/sales/saveAdvanceFromUnclaimRequest`,
    addPayment: `${baseUrl}/api/v1/sales/savePaymentRequest`,
    adjustAdvance: `${baseUrl}/api/v1/sales/saveAdjustmentRequest`,
    invoiceDetails: `${baseUrl}/api/v1/sales/getInvoiceDetails`,
    downloadInvoicePdf: `${baseUrl}/api/v1/sales/downloadInvoicePdf`,
    adjustAdvanceDetails: `${baseUrl}/api/v1/sales/getAdjustmentData`,
    updateAdvanceRequest: `${baseUrl}/api/v1/sales/updateAdvanceRequest`,
    updatePaymentRequest: `${baseUrl}/api/v1/sales/updatePaymentRequest`,
    updateAdjustmentRequest: `${baseUrl}/api/v1/sales/updateAdjustmentRequest`,
    leadApprovalList: `${goBaseUrl}/api/v1/sales/lead/leadApprovalList`,
    vendorRequestList: `${baseUrl}/api/v1/sales/vendorRequestList`,
    vendorOnboardedList: `${baseUrl}/api/v1/sales/vendorOnboardingList`,
    addVendorRequest: `${baseUrl}/api/v1/sales/addVendorRequest`,
    getDepartment: `${baseUrl}/api/v1/sales/getDepartment`,
    getPaymentRequestDetails: `${baseUrl}/api/v1/sales/getPaymentRequestDetails`,
    getVendorPO: `${baseUrl}/api/v1/sales/getVendorPO`,
    saveVendorPayment: `${baseUrl}/api/v1/sales/saveVendorPayment`,
    addVendorAdvance: `${baseUrl}/api/v1/sales/add-vendor-advance`,
    vendorPaymentList: `${baseUrl}/api/v1/sales/vendorPaymentList`,
    getVendorPaymentRequestList: `${baseUrl}/api/v1/sales/getVendorPaymentRequestList`,
    vendorPaymentDetails: `${baseUrl}/api/v1/sales/vendorPaymentDetails`,
    getVendorPaymentRequestDetail: `${baseUrl}/api/v1/sales/getVendorPaymentRequestDetail`,
    saveVendorPaymentRequest: `${baseUrl}/api/v1/sales/saveVendorPaymentRequest`,
    approvalVendorPaymentRequest: `${baseUrl}/api/v1/sales/approvalVendorPaymentRequest`,
    checkProjectExist: `${goBaseUrl}/api/v1/sales/lead/checkProjectExist`,
    getSubLob: `${baseUrl}/api/v1/sales/getSubLob`,
    getVendorDepartments: `${baseUrl}/api/v1/sales/get-vendor-department`,
    approveHoldRequest: `${baseUrl}/api/v1/sales/approveHoldRequest`,
    vendorEditRequest: `${baseUrl}/api/v1/sales/vendorEditRequest`,
    taxInvoiceListingLob: `${baseUrl}/api/v1/sales/taxInvoiceListingLob`,
    bulkChangeAssigneeForTaxInvoices: `${baseUrl}/api/v1/sales/bulkChangeAssigneeForTaxInvoices`,
    getPaymentRequestData: `${baseUrl}/api/v1/sales/getRequestedInvoice`,
    tagMismatchApprovalList: `${goBaseUrl}/api/v1/sales/lead/tagMismatchApprovalList`,
    tagApprovalDetails: `${goBaseUrl}/api/v1/sales/lead/tagApprovalDetails`,
    tagMismatchApproval: `${baseUrl}/api/v1/sales/lead/tagMismatchApproval`,
    tagMismatchReject: `${goBaseUrl}/api/v1/sales/lead/tagMismatchReject`,
    invoiceModificationRequest: `${baseUrl}/api/v1/sales/invoiceModificationRequest`,
    returnTagMrf: `${baseUrl}/api/v1/sales/lead/returnTagMrf`,
    vendorInvoiceRequestDetails: `${baseUrl}/api/v1/sales/vendor-invoice-request-details`,
    vendorInvoiceRequestList: `${baseUrl}/api/v1/sales/vendor-invoice-request-list`,
    invoiceRequestDetails: `${baseUrl}/api/v1/sales/getRequestedInvoiceDetails`,
    updateVendorPaymentStatus: `${baseUrl}/api/v1/sales/updateVendorPaymentStatus`,
    getSiteChallan: `${goBaseUrl}/api/v1/sales/lead/challan-for-site`,
    approveVendor: `${baseUrl}/api/v1/sales/approveVendor`,
    getVendorBankDetailFields: `${baseUrl}/api/v2/procurement/get-vendor-bank-detail-fields`,
    fetchGeoCity: `${goBaseUrl}/api/v1/fetchGeoCity`, // migrated to fusion-backend-go
    fetchGeoPincode: `${goBaseUrl}/api/v1/fetchGeoPincode`, // migrated to fusion-backend-go
    addVendorBankDetail: `${baseUrl}/api/v2/procurement/add-vendor-bank-detail`,
    getVendorAddressFields: `${baseUrl}/api/v2/procurement/get-vendor-address-fields`,
    addVendorAddress: `${baseUrl}/api/v2/procurement/add-vendor-address`,
    editVendorAddress: `${baseUrl}/api/v2/procurement/edit-vendor-address`,
    salesTargetsList: `${fusionServiceUrl}/api/sales-targets/list`,
    salesTargetsSetTargets: `${fusionServiceUrl}/api/sales-targets/set-targets`,
    salesTargetsSetWeeklyTargets: `${fusionServiceUrl}/api/sales-targets/set-weekly-targets`,
    salesTargetsLatestPeriod: `${fusionServiceUrl}/api/sales-targets/target-periods/latest`,
    salesTargetsPeriods: `${fusionServiceUrl}/api/sales-targets/target-periods`,
    salesTargetsUpdatePeriod: `${fusionServiceUrl}/api/sales-targets/target-periods`,
    salesTargetsCloseAndCreateNext: `${fusionServiceUrl}/api/sales-targets/target-periods/close-and-create-next`,
    salesTargetsUploadAdditionalAchievements: `${fusionServiceUrl}/api/sales-targets/upload-additional-achievements`,
  },
  businessAndClientLocation: {
    addLocation: `${goBaseUrl}/api/v1/sales/client/addLocation`,
    getClientList: `${goBaseUrl}/api/v1/sales/lead/getClientList`,
    checkGstNumber: `${baseUrl}/api/v1/installation/site/checkGstNumber`,
  },
  postSalesList: {
    type: `${goBaseUrl}/api/v1/sales/lead/listSupply`,
    listCorporate: `${baseUrl}/api/v1/sales/lead/listCorporate`,
    listApartments: `${goBaseUrl}/api/v1/sales/lead/listApartments`,
    listAlliance: `${goBaseUrl}/api/v1/sales/lead/listAlliance`,
    createSiteInspectionForm: `${goBaseUrl}/api/v1/sales/lead/createSiteInspectionForm`,
    inspectionCreated: `${goBaseUrl}/api/v1/sales/lead/inspectionCreated`,
    viewSiteInspectionForms: `${goBaseUrl}/api/v1/sales/lead/viewSiteInspectionForms`,
    listSiteInspectionManagers: `${goBaseUrl}/api/v1/sales/lead/listSiteInspectionManagers`,
    changeSiteInspectionManager: `${goBaseUrl}/api/v1/sales/lead/changeSiteInspectionManager`
  },
  followUpList: {
    list: `${baseUrl}/api/v1/sales/lead/followUp/fetch`,
  },
  viewPoc: {
    list: `${goBaseUrl}/api/v1/sales/lead/poc/details`, // migrated to fusion-backend-go
    status: `${goBaseUrl}/api/v1/sales/lead/poc/status/update`,
    bastatus: `${goBaseUrl}/api/v1/sales/lead/poc/status/statusBaUpdate`,
  },
  followUp: {
    dropDown: `${baseUrl}/api/v1/sales/lead/followUp/prerequisite`,
    saveForm: `${baseUrl}/api/v1/sales/lead/followUp/create`,
    followUpDetails: `${baseUrl}/api/v1/sales/lead/followUp`,
  },
  preSalesSupply: {
    dropDownList: `${baseUrl}/api/v1/sales/lead/presale/supply`,
    create: `${baseUrl}/api/v1/sales/presale/supply/store`,
    getBlockedUserData: `${goBaseUrl}/api/v1/sales/get-blocked-user-data`, // migrated to fusion-backend-go (ratings/blocked_user)
    updateUserBlockStatus: `${goBaseUrl}/api/v1/sales/update-user-block-status`, // migrated to fusion-backend-go (ratings/blocked_user)
  },
  locations: {
    city: `${goBaseUrl}/api/v1/fetchCity`, // migrated to fusion-backend-go
    zone: `${goBaseUrl}/api/v1/fetchZone?city_id=`, // migrated to fusion-backend-go
    state: `${goBaseUrl}/api/v1/fetchGeoState`, // migrated to fusion-backend-go
    area: `${goBaseUrl}/api/v1/fetchArea?zone_id=`, // migrated to fusion-backend-go
    pinCode: `${goBaseUrl}/api/v1/fetchGeoCityStateOnPincode?pincode=`, // migrated to fusion-backend-go
    locationType: `${goBaseUrl}/api/v1/sales/lead/locationTypes`,
  },
  createLead: {
    corporate: `${baseUrl}/api/v1/sales/lead/createCorporate`,
    apartment: `${baseUrl}/api/v1/sales/lead/createApartments`,
    b2bAlliance: `${baseUrl}/api/v1/sales/lead/createAlliance`,
    supply: `${baseUrl}/api/v1/sales/lead/createSupply`,
    b2bDropdown: `${baseUrl}/api/v1/sales/lead/createData/alliance`,
    projectOnboarding: `${goBaseUrl}/api/v1/sales/lead/create-project-onboarding`,
    updateprojectOnboarding: `${goBaseUrl}/api/v1/sales/lead/update-project-onboarding`,
    financeProjectOnboarding: `${baseUrl}/api/v1/sales/lead/finance-project-onboarding`,
  },
  fileUpload: {
    imageUpload: `${baseUrl}/api/v1/fileUpload/image`,
    imageUploadPublic: `${baseUrl}/api/v1/fileUpload/imagePublic`,
    docUpload: `${baseUrl}/api/v1/fileUpload/document`,
    excelUpload: `${baseUrl}/api/v1/fileUpload/excel`,
    mediaUpload: `${baseUrl}/api/v1/fileUpload/media`,
    docUploadPublic: `${baseUrl}/api/v1/fileUpload/documentPublic`,
    carnivalDocumentPublic: `${baseUrl}/api/v1/fileUpload/carnivalDocumentPublic`,
    /** Multipart form upload: file + doc_name, service_name, extension, is_public, doc_type, is_view_only. Returns URL. */
    documentUploadForm: `${fusionServiceUrl}/api/file-upload/document`,
  },
  postSalesNew: {
    createPostNew: `${goBaseUrl}/api/v1/sales/postsaleNew/corporate/storeData`,
    getPostNew: `${goBaseUrl}/api/v1/sales/postsaleNew/corporate/getData`,
    createSolutionProduct: `${goBaseUrl}/api/v1/sales/postsaleNew/corporate/storeSolutionProduct`,
    createClientDataForComm: `${goBaseUrl}/api/v1/sales/postsaleNew/corporate/storeClient`,
    saveAdvancePayments: `${goBaseUrl}/api/v1/sales/postsaleNew/corporate/storeAdvPayment`,
    postSalesInstallation: `${goBaseUrl}/api/v1/sales/postsaleNew/corporate/postSalesInstallation`,
    postSalesInvoiceModule: `${baseUrl}/api/v1/sales/postsaleNew/corporate/postSalesInvoiceModule`,
    postSalesMileStone: `${baseUrl}/api/v1/sales/postsaleNew/corporate/postSalesMileStone`,
    getOnDemandServices: `${goBaseUrl}/api/v1/sales/postsaleNew/corporate/get-all-services-for-on-demand`,
    getMasterInventory: `${goBaseUrl}/api/v1/sales/postsaleNew/corporate/getMasterInventory`,
    postCapexInvoiceModule: `${goBaseUrl}/api/v1/sales/postsaleNew/corporate/store-capex-invoice-data`,
    contractInvoicePreview: `${goBaseUrl}/api/v1/sales/contract/invoice-preview`,
  },
  postSales: {
    corporate: `${goBaseUrl}/api/v1/sales/lead/postsale/corporate?lead_id=`,
    corporateContract: `${goBaseUrl}/api/v1/sales/lead/postsale/corporateContract`,
    appartment: `${goBaseUrl}/api/v1/sales/lead/postsale/appartment?lead_id=`,
    appartmentContract: `${goBaseUrl}/api/v1/sales/lead/postsale/appartmentContract?lead_id=`,
    supply: `${baseUrl}/api/v1/sales/lead/postsale/supply?lead_id=`,
    alliances: `${goBaseUrl}/api/v1/sales/lead/postsale/alliances?lead_id=`,
    createPostCorporate: `${baseUrl}/api/v1/sales/postsale/corporate/store`,
    createPostApartment: `${baseUrl}/api/v1/sales/postsale/apartment/store`,
    getMaterial: `${baseUrl}/api/v1/common/getProductByCatId?cat_id=`,
    getBrand: `${baseUrl}/api/v1/common/getBrandByCatId?cat_id=`,
    getTag: `${baseUrl}/api/v1/common/getTag`,
    getRevenueNature: `${goBaseUrl}/api/v1/sales/lead/getRevenueNature`,
    checkManagementFeeApplicable: `${goBaseUrl}/api/v1/sales/lead/checkManagementFeeApplicable`,
    getSolution: `${baseUrl}/api/v1/common/getSolution`,
    createPostSupply: `${baseUrl}/api/v1/sales/postsale/supply/store`,
    apartmentContractData: `${goBaseUrl}/api/v1/sales/lead/postsale/getContractAptData`,
    contractRevenueType: `${goBaseUrl}/api/v1/sales/lead/revenue-details`,
    editApartmentContract: `${baseUrl}/api/v1/sales/postsale/apartment/storeEditApt`,
    postInvoiceNumber: `${goBaseUrl}/api/v1/sales/postsale/apartment/postInvoiceNumber`,
    corpContractData: `${goBaseUrl}/api/v1/sales/lead/postsale/getContractCorpData`,
    editCorpContract: `${baseUrl}/api/v1/sales/postsale/apartment/storeEditCorp`,
    getSolutionStages: `${baseUrl}/api/v1/sales/postsale/getSolutionStages`,
    saveTutorialData: `${baseUrl}/api/v1/tutorial-question/data-save`,
    fetchTutorialData: `${baseUrl}/api/v1/tutorial-question/fetch-tutorial-data`,
    valetIncentiveData: `${baseUrl}/api/v1/valet-incentive/valet-incentive-data`,
    fetchIncentiveListing: `${baseUrl}/api/v1/valet-incentive/valet-incentive-list`,
    editIncentiveData: `${baseUrl}/api/v1/valet-incentive/edit-incentive-data`,
    lastFiveTransactionData: `${baseUrl}/api/v1/valet-incentive/last-five-transaction`,
    supplyContractData: `${goBaseUrl}/api/v1/sales/lead/postsale/getSupplyContractData`,
    editSupplyContract: `${goBaseUrl}/api/v1/sales/postsale/storeEditSupplyContract`,
    getSalesIncentiveSites: `${baseUrl}/api/v1/sales/postsale/incentiveSites`,
    getLeadCommertialDetails: `${baseUrl}/api/v1/sales/postsale/commertialLeadDetails`,
    saveSalesIncentive: `${baseUrl}/api/v1/sales/postsale/saveIncentive`,
    getAllIncentives: `${baseUrl}/api/v1/sales/postsale/getIncentiveList`,
    getSeniorBeneficiary: `${baseUrl}/api/v1/sales/postsale/getUserSeniorBeneficiary`,
    getEditIncentiveData: `${baseUrl}/api/v1/sales/postsale/getEditIncentiveData`,
    approveOrRejectIncentive: `${baseUrl}/api/v1/sales/postsale/approveOrRejectIncentive`,
    getIncentiveListFinance: `${baseUrl}/api/v1/sales/postsale/incentiveListForFinance`,
    acceptIncetiveApproval: `${baseUrl}/api/v1/sales/postsale/approveIncentiveByFinance`,
    rejectIncentiveApproval: `${baseUrl}/api/v1/sales/postsale/rejectIncentiveByFinance`,
    getUserSeniorIncentiveLists: `${baseUrl}/api/v1/sales/postsale/getUserSeniorIncentiveLists`,
    excelExportIncentive: `${baseUrl}/api/v1/sales/postsale/exportIncentiveToExcel`,
    uploadUserSeniorIncentiveUtr: `${baseUrl}/api/v1/sales/postsale/uploadUtrFile`,
    getHeadBeneficiary: `${baseUrl}/api/v1/sales/postsale/getHeadBeneficiary`,
    getCalculatedIncentiveAmount: `${baseUrl}/api/v1/sales/postsale/getCalculatedIncentive`,
    getUnclaimedList: `${baseUrl}/api/v1/sales/listUnclaimedTrans`,
    saveTransactionClaim: `${goBaseUrl}/api/v1/sales/saveTransactionClaim`,
    getClaimData: `${goBaseUrl}/api/v1/sales/getClaimData`,
    getAllClientsForFinanceBusiness: `${goBaseUrl}/api/v1/sales/lead/postsale/getAllClientsForFinanceBusiness`,
    unclaimedSendToModification: `${goBaseUrl}/api/v1/sales/back-to-modification`,
    contractCategoryService: `${goBaseUrl}/api/v1/sales/lead/category-service`,
    b2bInvoiceList: `${baseUrl}/api/v1/sales/invoice-module/b2b-invoice-list`,
    variableValetContractInvoice: `${reconApiBase}/v1/fusion/service-invoice/list`,
    valetServiceLineItemsUpdate: `${baseUrl}/api/v1/sales/invoice-module/b2b-invoice-line-item-update`,
    valetServiceLineItemsApprovalList: `${baseUrl}/api/v1/sales/invoice-module/b2b-invoice-line-item-approval-list`,
    valetServiceLineItemsByInvoiceId: `${baseUrl}/api/v1/sales/invoice-module/b2b-invoice-line-item-by-invoice-id`,
    valetServiceLineItemsApprovalRejection: `${baseUrl}/api/v1/sales/invoice-module/b2b-invoice-line-item-approve-rejection`,
    convertServiceInvoice: `${goBaseUrl}/api/v1/sales/service-invoice/convert`,
    valetIncentiveBulkApproval: `${baseUrl}/api/v1/valet-incentive/valet-earnings/bulk-approval`,
    verifyInvoiceNumbers: `${goBaseUrl}/api/v1/sales/verify-invoice-numbers`,
    editClientDetails: `${goBaseUrl}/api/v1/sales/edit-client-details`,
    capexContractInvoice: `${baseUrl}/api/v1/sales/invoice-module/capex-invoice-list`,
    updateContractInvoice: `${baseUrl}/api/v1/sales/invoice-module/update-capex-invoice-status`,
  },
  poc: {
    addPoc: `${goBaseUrl}/api/v1/sales/lead/poc/add`,
    editPoc: `${goBaseUrl}/api/v1/sales/lead/poc/update`,
    getPocById: `${goBaseUrl}/api/v1/sales/lead/poc/fetch`,
  },
  gates: {
    gateTypeList: `${goBaseUrl}/api/v1/sales/lead/gateSetupTypes`,
    addGate: `${baseUrl}​/api​/v1​/sales​/lead/addGate`,
    fetchLeadGate: `${goBaseUrl}/api/v1/sales/lead/fetchLeadGate`,
    addApartmentGate: `${baseUrl}/api/v1/sales/presale/apartment/store`,
    addCorporateGate: `${baseUrl}/api/v1/sales/presale/corporate/store`,
  },
  preB2bAlliance: {
    allianceDropdown: `${baseUrl}/api/v1/sales/lead/presale/alliances?lead_id=`,
    addPreAlliance: `${baseUrl}/api/v1/sales/presale/alliances/store`,
  },
  approvals: {
    // accept: `${baseUrl}/api/v1/sales/leads/approve`,
    accept: `${goBaseUrl}/api/v1/sales/contract/approval`,
    reject: `${goBaseUrl}/api/v1/sales/leads/reject`, // migrated to fusion-backend-go
    locApprovalList: `${baseUrl}/api/v1/installation/site/fetchSiteLocationApprovalList`,
    locApprovalAccept: `${baseUrl}/api/v1/installation/site/approvedSiteLocationById?site_location_id=`,
    locApprovalReject: `${baseUrl}/api/v1/installation/site/rejectSiteLocationById?site_location_id=`,
    mrfApprovalList: `${baseUrl}/api/v1/installation/site/fetchSiteMrfApproval`,
    mrfApprovalAccept: `${baseUrl}/api/v1/installation/site/approvedSiteMrfApproval?site_id=`,
    mrfApprovalReject: `${baseUrl}/api/v1/installation/site/rejectSiteMrfApproval?site_id=`,
    acceptLead: `${baseUrl}/api/v1/sales/leads/approveSalesLead`,
    rejectLead: `${baseUrl}/api/v1/sales/leads/rejectSalesLead`,
    rejectOrApprovePr: `${baseUrl}/api/v1/installation/site/approveOrRejectPr`,
    saveContractLogs: `${goBaseUrl}/api/v1/sales/lead/save-contract-log`,
  },
  postB2bAlliance: {
    dropdownValues: `${goBaseUrl}/api/v1/sales/lead/postsale/alliances?lead_id=`,
    addPostAlliance: `${goBaseUrl}/api/v1/sales/postsale/alliances/store`,
  },
  viewDetails: {
    view: `${goBaseUrl}/api/v1/sales/lead/view`,
    getLeadType: `${goBaseUrl}/api/v1/sales/lead/getLeadType`,
    viewContract: `${goBaseUrl}/api/v1/sales/lead/viewContract`,
    discardContract: `${goBaseUrl}/api/v1/sales/lead/discardContract`,
    viewSiteDetails: `${goBaseUrl}/api/v1/sales/lead/viewSiteDetails`,
    mapProject: `${goBaseUrl}/api/v1/sales/lead/project-map`, // migrated to fusion-backend-go
    projectMappingDetails: `${baseUrl}/api/v1/sales/lead/mapping-project-details`,
  },
  assignee: {
    dropdownData: `${goBaseUrl}/api/v1/sales/lead/changeAssigneeData`,
    postAssignee: `${goBaseUrl}/api/v1/sales/lead/assign`,
  },
  listFilterData: {
    fillterDropdown: `${goBaseUrl}/api/v1/sales/lead/listFilterData`,
    fillterVendorDropdown: `${goBaseUrl}/api/v1/sales/lead/listVendorFilterData`,
    fetchZone: `${goBaseUrl}/api/v1/fetchZone?city_id=`, // migrated to fusion-backend-go
  },
  tagInfo: {
    tagSearch: `${baseUrl}/api/v1/sales/tag-details/`,
    vehicleDetails: `${baseUrl}/api/v1/sales/activity-list`,
    auditLogs: `${baseUrl}/api/v1/sales/auditLogs?limit=20`,
    // auditLogs: `${vehicleBaseUrl}/api/v1/sales/auditLogs?limit=20`,
    tagSearchByVehicleNo: `${baseUrl}/api/v1/sales/tag-details-by-vehicle-no`,
  },
  installation: {
    siteStatusCSV: `${baseUrl}/api/v1/installation/site/site-status-as-csv`,
    siteListing: `${baseUrl}/api/v1/installation/site/siteList`,
    taskListing: `${baseUrl}/api/v1/installation/site/taskList`,
    getSiteLog: `${baseUrl}/api/v1/installation/site/getSiteLog`,
    firAutofill: `${baseUrl}/api/v1/installation/site/firAutofill`,
    corporateAutofillData: `${baseUrl}/api/v1/installation/site/corporate-autofill-data`,
    meetingList: `${goBaseUrl}/api/v1/installation/meeting/list`, // migrated to fusion-backend-go
    createMeeting: `${goBaseUrl}/api/v1/installation/meeting/create`, // migrated to fusion-backend-go
    pocList: `${baseUrl}/api/v1/installation/site/pocLists`,
    targetData: `${baseUrl}/api/v1/installation/site/siteInspectionStatges`,
    postTargetData: `${baseUrl}/api/v1/installation/site/siteInspectionExpectedDates`,
    postVerifyData: `${baseUrl}/api/v1/installation/site/postVerifyData`,
    // siteStage: `${baseUrl}/api/v1/installation/site/fetchSiteInspectionStagesData?site_id=1`,
    autofillData: `${baseUrl}/api/v1/installation/site/autofill-data`,
    meetingById: `${baseUrl}/api/v1/installation/meeting/view`,
    cancelMeeting: `${goBaseUrl}/api/v1/installation/meeting/cancel`, // migrated to fusion-backend-go
    completeMeeting: `${goBaseUrl}/api/v1/installation/meeting/complete`, // migrated to fusion-backend-go
    siteStage: `${baseUrl}/api/v1/installation/site/fetchSiteInspectionStagesData`,
    siteStageStatus: `${baseUrl}/api/v1/installation/site/siteStageStatus`,
    siteUnhold: `${baseUrl}/api/v1/installation/site/siteUnhold`,
    siteDismantle: `${baseUrl}/api/v1/installation/site/siteDismantle`,
    siteLERT: `${baseUrl}/api/v1/installation/site/siteLERT`,
    getSiteAbortApproval: `${baseUrl}/api/v1/installation/site/siteAbortApproval`,
    siteStageStatusApproval: `${baseUrl}/api/v1/installation/site/siteStageStatusApproval`,
    siteLertApproval: `${baseUrl}/api/v1/installation/site/siteLertApproval`,
    siteInspectionStage: `${baseUrl}/api/v1/installation/site/inspection/stage`,
    siteInspectionStageSolution: `${baseUrl}/api/v1/installation/site/inspection/stageSolution`,
    postSolution: `${baseUrl}/api/v1/installation/site/inspection/postSolution`,
    assigneeData: `${baseUrl}/api/v1/installation/site/changeAssigneeData`,
    siteAssign: `${baseUrl}/api/v1/installation/site/assign`,
    inventoryCheckList: `${baseUrl}/api/v1/installation/inventory/inventoryChecklist`, // migrated to fusion-backend-go
    gateDetail: `${baseUrl}/api/v1/installation/site/getGateDetail`,
    siteInformationChecklist: `${baseUrl}/api/v1/installation/site/siteInformationChecklist`,
    civilCheckList: `${baseUrl}/api/v1/installation/site/civilChecklistQuestions`,
    hardwareInstall: `${baseUrl}/api/v1/installation/site/hardware_installation_checklist`,
    handOver: `${baseUrl}/api/v1/installation/site/handover_checklist`,
    vendorList: `${baseUrl}/api/v1/installation/site/vendorAllocation`,
    vendorAllocate: `${baseUrl}/api/v1/installation/site/vendorAllocated`,
    updateVendorAllocation: `${baseUrl}/api/v2/site/update-vendor-allocation`,
    vendorServiceDetail: `${baseUrl}/api/v1/installation/site/fetchVendorService`,
    postVendorService: `${baseUrl}/api/v1/installation/site/createPurchaseRequisition`,
    gateInfo: `${baseUrl}/api/v1/installation/site/details`,
    saveSiteInformation: `${baseUrl}/api/v1/installation/site/site_inspection_checklist`,
    saveCivilCheckList: `${baseUrl}/api/v1/installation/site/civil_checklist`,
    saveHardwareInstall: `${baseUrl}/api/v1/installation/site/hardware_installation_checklist`,
    saveHandOver: `${baseUrl}/api/v1/installation/site/handover_material_checklist`,
    gateInventory: `${baseUrl}/api/v1/installation/site/gateInventory`,
    siteLocationApproval: `${baseUrl}/api/v1/installation/site/createSiteLocationApproval`,
    siteRepository: `${baseUrl}/api/v1/installation/site/repository`,
    getSiteRepository: `${baseUrl}/api/v1/installation/site/get-repository`,
    mrfDetail: `${baseUrl}/api/v1/installation/site/mrf_details`,
    addReportDetails: `${baseUrl}/api/v1/installation/site/add_report_details`,
    siteEngineerList: `${baseUrl}/api/v1/installation/siteEngineer/fetch`,
    siteEngineerDetails: `${baseUrl}/api/v1/installation/siteEngineer/view`,
    sendApproval: `${baseUrl}/api/v1/installation/site/send_for_approval`,
    getMaterialDelivery: `${baseUrl}/api/v1/installation/site/fetchInstallatioMaterialReceiving`,
    getTagDelivery: `${baseUrl}/api/v1/installation/site/fetchInstallationTag`,
    getTags: `${baseUrl}/api/v1/installation/site/getTags`,
    postMaterialDelivery: `${baseUrl}/api/v1/installation/site/installatioMaterialReceiving`,
    postTagDelivery: `${baseUrl}/api/v1/installation/site/installationTagReceiving`,
    statusUpdate: `${baseUrl}/api/v1/installation/site/sitesInspectionStagesDatesStatusUpdate`,
    generateReport: `${baseUrl}/api/v2/site/generate-report`,
    handoverValetContractPreview: `${reconApiBase}/v1/admin-app/business/handover-valet-contract-preview/`,
    sendtoProcurement: `${baseUrl}/api/v1/installation/site/createMaterialRequisition`,
    locationApprovalPending: `${baseUrl}/api/v1/installation/site/fetchLocationApprovalPending`,
    pocListBySite: `${baseUrl}/api/v1/installation/site/pocListBySite`,
    sendReportMail: `${baseUrl}/api/v1/installation/site/send-report-mail`,
    siteFilters: `${baseUrl}/api/v1/installation/site/filters`,
    mrfViewGateWise: `${baseUrl}/api/v1/installation/site/mrf/view`,
    editMrf: `${baseUrl}/api/v1/installation/site/mrf/update`,
    deleteMrf: `${baseUrl}/api/v1/installation/site/mrf/delete`,
    locationChange: `${baseUrl}/api/v1/installation/site/validate/location`,
    checkChange: `${baseUrl}/api/v1/installation/site/check/location`,
    getSiteInfoChecklist: `${baseUrl}/api/v1/installation/site/siteInformationQuestionAnswers`,
    getCitiesList: `${baseUrl}/api/v1/installation/site/cityList`,
    getSitesByCityId: `${baseUrl}/api/v1/installation/site/getSitesByCity`,
    getSubHardwareDropDown: `${baseUrl}/api/v1/installation/sub-hardware-dropdown`,
    getSiteRepositoryFinance: `${baseUrl}/api/v1/installation/site/getRepositoryByCommId`,
    firstInteractionChecklist: `${baseUrl}/api/v1/installation/site/firstInteractionChecklist`,
    saveFirstInteractionCheckList: `${baseUrl}/api/v1/installation/site/saveFirstInteractionChecklist`,
    configurationAndTestingChecklist: `${baseUrl}/api/v1/installation/site/configTestingChecklist`,
    saveConfigurationAndTesting: `${baseUrl}/api/v1/installation/site/saveConfigurationAndTesting`,
    saveSiteIssue: `${goBaseUrl}/api/v1/installation/site/saveSiteIssue`,
    getSiteIssues: `${goBaseUrl}/api/v1/installation/site/fetchIssues`,
    createProjectConfig: `${goBaseUrl}/api/v1/installation/createProjectConfig`, // migrated to fusion-backend-go
    getProjectConfig: `${goBaseUrl}/api/v1/installation/getProjectConfig`, // migrated to fusion-backend-go
    siteListForEngineer: `${baseUrl}/api/v1/installation/site/siteListForEngineer`,
    siteListingForAsset: `${baseUrl}/api/v1/installation/site/fetchSitesForAssetMapping`,
    getgatesByleadId: `${baseUrl}/api/v1/installation/site/getgatesByleadId`,
    getParentMaterials: `${baseUrl}/api/v1/installation/site/getParentMaterials`,
    getParentMaterialsBySiteId: `${baseUrl}/api/v1/installation/site/getParentMaterialsBySiteId`,
    getAssetsAndMakeData: `${baseUrl}/api/v1/installation/site/getAssetsAndMakeData`,
    saveSitesAssetsGateWise: `${baseUrl}/api/v1/installation/site/saveSitesAssetsGateWise`,
    getAssetsInfoData: `${baseUrl}/api/v1/installation/site/getAssetsInfoData`,
    markCompleteAssetMapping: `${baseUrl}/api/v1/installation/site/markCompleteAssetMapping`,
    getgatesByContratctId: `${baseUrl}/api/v1/installation/site/getgatesByContratctId`,
    markCompleteAssetMappingSite: `${baseUrl}/api/v1/installation/site/markCompleteAssetMappingSite`,
    getClientAddressForContractMapping: `${baseUrl}/api/v1/installation/site/getClientAddressForContractMapping`,
    mapClientAddressToContract: `${baseUrl}/api/v1/installation/site/mapClientAddressToContract`,
    mapMasterClientAddressToContract: `${baseUrl}/api/v1/installation/site/mapMasterClientAddressToContract`,
    firFormSubmit: `${baseUrl}/api/v1/installation/site/firFormSubmit`,
    changeSiteStateToExpired: `${baseUrl}/api/v1/installation/site/make-site-expired`,
    changeSiteStateEnableDispute: `${baseUrl}/api/v1/installation/site/make-site-dispute-enable`,
    getSiteAbortApprovalFinance: `${baseUrl}/api/v1/installation/site/siteAbortApprovalForFinance`,
    getapproveRejectDataFinance: `${baseUrl}/api/v1/installation/site/approval-rejected-finance`,
    saveasDraft: `${baseUrl}/api/v1/installation/site/saveAsDraft`,
    getPosRequirement: `${baseUrl}/api/v1/installation/site/fetchPosRequirement`,
    statusUpdatePos: `${baseUrl}/api/v1/installation/site/sitesInspectionStagesDatesStatusUpdatePos`,
    sitePosReplaceAndReturn: `${baseUrl}/api/v1/installation/site/public-site-pos`,
    getPosShipmentAndReasons: `${baseUrl}/api/v1/installation/site/fetchPosShipmentAndReasons`,
    fetchAmountAgainstPos: `${baseUrl}/api/v1/installation/site/fetchAmountAgainstReason`,
    replaceOrReturnPos: `${baseUrl}/api/v1/installation/site/replaceOrReturnPosOnSite`,
    valetGoLiveChecklist: `${baseUrl}/api/v1/installation/site/valetGoLiveChecklist`,
    postValetGoLive: `${baseUrl}/api/v1/installation/site/saveValetGoLiveChecklist`,
    saveDashboardTraining: `${baseUrl}/api/v1/installation/site/saveDashboardTrainingData`,
    getDashboardTrainingDetails: `${baseUrl}/api/v1/installation/site/getDashboardTrainingDetails`,
    getSiteCarnivalChecklist: `${baseUrl}/api/v1/installation/site/getSiteCarnivalChecklist`,
    postCarnivalData: `${baseUrl}/api/v1/installation/site/postCarnivalData`,
    getCarnivalCompletedDetails: `${baseUrl}/api/v1/installation/site/getCarnivalCompletedDetails`,
    saveDashboardTrainingChecklist: `${baseUrl}/api/v1/installation/site/saveDashboardTrainingChecklist`,
    getDashboardTrainingChecklist: `${baseUrl}/api/v1/installation/site/getDashboardTrainingChecklist`,
    dismantleSite: `${goBaseUrl}/api/v1/installation/dismantle-site`, // migrated to fusion-backend-go
    dismantleMrf: `${baseUrl}/api/v1/installation/dismantle-mrf`, // migrated to fusion-backend-go
    contractDate: `${goBaseUrl}/api/v1/installation/contract-date`, // migrated to fusion-backend-go
    dismantleMrfBySiteId: `${goBaseUrl}/api/v1/installation/get-dismantle-mrf`, // migrated to fusion-backend-go
    fetchPosDevicesForEmp: `${baseUrl}/api/v1/installation/site/fetchPosDevicesForEmp`,
    getInstallationDateChangeListing: `${baseUrl}/api/v1/installation/site/get-installation-date-listing`,
    viewInstallationDateChangeDetail: `${baseUrl}/api/v1/installation/site/view-installation-date-request-details`,
    createInstallationDateChange: `${baseUrl}/api/v1/installation/site/create-installation-date-request`,
    approveInstallationDateChange: `${baseUrl}/api/v1/installation/site/approve-installation-date-request`,
    insertDocumentsStageData: `${baseUrl}/api/v1/installation/site/save-documents-data`,
    getSiteConsumablesItems: `${baseUrl}/api/v1/installation/site/getSiteConsumablesItems`,
    updateSiteConsumesByOps: `${baseUrl}/api/v1/installation/site/updateSiteConsumesByOps`,
    requiredDocumentDropdown: `${baseUrl}/api/v1/installation/site/required-document-dropdown`,
    saveCompetitionMapping: `${baseUrl}/api/v1/installation/site/save-competition-mapping`,
    competitionMappingList: `${baseUrl}/api/v1/installation/site/competition-mapping-list`,
    fetchSiteNameUsingLatLong: `${baseUrl}/api/v1/installation/site/fetch-site-name`,
    approvePRRequest: `${baseUrl}/api/v2/procurement/approvePurchaseRequisition`,
    updatePRItems: `${baseUrl}/api/v2/procurement/updatePRItems`,
  },
  maintenance: {
    fetchMaterials: `${baseUrl}/api/v1/maintenance/fetchMaterials`,
    materialInspected: `${baseUrl}/api/v1/maintenance/materialInspected`,
    saveMaterialInspection: `${baseUrl}/api/v1/maintenance/saveMaterialInspection`,
    fetchMaterialInspection: `${baseUrl}/api/v1/maintenance/fetchMaterialInspection`,
    setInspectionForm: `${baseUrl}/api/v1/maintenance/setInspectionForm`,
    getInspectionForm: `${baseUrl}/api/v1/maintenance/getInspectionForm`,
    sendInspectionForm: `${baseUrl}/api/v1/maintenance/sendInspectionForm`,
    sendInspectionMail: `${baseUrl}/api/v1/maintenance/sendInspectionMail`,
    viewAssigneeData: `${baseUrl}/api/v1/maintenance/viewAssigneeData`,
    fetchPmDashboard: `${baseUrl}/api/v1/maintenance/fetchPmDashboard`,
    fetchSitesAndGates: `${baseUrl}/api/v1/maintenance/fetchSitesAndGates`,
    goLiveChangeAssignee: `${baseUrl}/api/v1/maintenance/site/change/assignee`,
    fetchGoLiveSites: `${baseUrl}/api/v1/maintenance/fetchGoLiveSites`,
    fetchGatesMaintenanceMaterials: `${baseUrl}/api/v1/maintenance/fetchGatesMaintenanceMaterials`,
    fetchGatesMaintenanceDetails: `${baseUrl}/api/v1/maintenance/fetchGatesMaintenanceDetails`,
    // fetchMaintenanceCategoryType: `${baseUrl}/api/v1/maintenance/fetchCategory`,
    fetchMaintenanceCategory: `${baseUrl}/api/v1/maintenance/fetchMaintenanceCategory`,
    fetchMaintenanceMaterialList: `${baseUrl}/api/v1/maintenance/fetchMaintenanceMaterialList`,
    fetchMaintenancePMSites: `${baseUrl}/api/v1/maintenance/fetchMaintenancePMSites`,
    pmChecklist: `${baseUrl}/api/v1/maintenance/checklist/questions`,
    postPmData: `${baseUrl}/api/v1/maintenance/pm/data`,
    postPmAnswer: `${baseUrl}/api/v1/maintenance/post/answers`,
    fetchMaintenanceMonths: `${baseUrl}/api/v1/maintenance/fetchMaintenanceMonths`,
    downloadPMList: `${baseUrl}/api/v1/maintenance/downloadPMList`,
    uploadPMList: `${baseUrl}/api/v1/maintenance/uploadPMList`,
    fetchPMTickets: `${baseUrl}/api/v1/maintenance/fetchPMTickets`,
    PMTicketDetails: `${baseUrl}/api/v1/maintenance/ticket/view`,
    fetchUserAssignee: `${baseUrl}/api/v1/maintenance/fetchUserAssignee`,
    storeSchedulePM: `${baseUrl}/api/v1/maintenance/storeSchedulePM`,
    storeScheduleProjectPM: `${baseUrl}/api/v1/maintenance/storeScheduleProjectPM`,
    pmticketUpdateStatus: `${baseUrl}/api/v1/maintenance/ticket/update/status`,
    postRemarks: `${baseUrl}/api/v1/maintenance/ticket/save/remarks`,
    getSiteGates: `${baseUrl}/api/v1/maintenance/getSiteGates`,
    ticketAssignment: `${baseUrl}/api/v1/maintenance/ticket/assignment`,
    approvePmSite: `${baseUrl}/api/v1/maintenance/approve/pm/site`,
    rejectPmSite: `${baseUrl}/api/v1/maintenance/reject/pm/site`,
    pmSendApproval: `${baseUrl}/api/v1/maintenance/pm/send/approval`,
    pmStatus: `${baseUrl}/api/v1/maintenance/pm/sites/status`,
    pmTicketStatus: `${baseUrl}/api/v1/maintenance/pm/tickets/status`,
    pmTicketAssignee: `${baseUrl}/api/v1/maintenance/pm/tickets/assignees`,
    rmList: `${baseUrl}/api/v1/maintenance/rm/fetchReactiveMaintenance`,
    rmSoftwareList: `${baseUrl}/api/v1/maintenance/rm/fetchSoftwareReactiveMaintenance`,
    rmHardwareList: `${baseUrl}/api/v1/maintenance/rm/fetchHardwareReactiveMaintenance`,
    rmTicketLog: `${baseUrl}/api/v1/maintenance/rm/rmTicketLog`,
    rmListReport: `${baseUrl}/api/v1/maintenance/rm/fetchReactiveMaintenanceReport`,
    viewRmList: `${baseUrl}/api/v1/maintenance/rm/viewReactiveMaintenance`,
    rmUpdateStatus: `${baseUrl}/api/v1/maintenance/rm/update/status`,
    rmUpdateRca: `${baseUrl}/api/v1/maintenance/rm/updateRca`,
    rmAssignment: `${baseUrl}/api/v1/maintenance/rm/assignment`,
    employeeTicketsList: `${baseUrl}/api/v1/employee/fetchEmployeeTickets`,
    viewEmployeeTickets: `${baseUrl}/api/v1/employee/viewEmployeeTickets`,
    emUpdateStatus: `${baseUrl}/api/v1/employee/update/status`,
    emAssignment: `${baseUrl}/api/v1/employee/assignment`,
    postEmployeeRemark: `${baseUrl}/api/v1/employee/save/remarks`,
    postRmRemark: `${baseUrl}/api/v1/maintenance/rm/save/remarks`,
    rmStatus: `${baseUrl}/api/v1/maintenance/rm/status`,
    getRMMaterial: `${baseUrl}/api/v1/maintenance/rm/getMaterial`,
    emStatus: `${baseUrl}/api/v1/employee/status`,
    pmSiteViewReport: `${baseUrl}/api/v1/maintenance/checklist/view`,
    pmSiteReport: `${baseUrl}/api/v1/maintenance/send/report`,
    pmSiteReportDownload: `${baseUrl}/api/v1/maintenance/download/report`,
    // createMrfForMaintenance: `${baseUrl}/api/v1/maintenance/createMrfForMaintenance`,
    siteSchedule: `${baseUrl}/api/v1/maintenance/site/schedule`,
    scheduledTicket: `${baseUrl}/api/v1/maintenance/sites/scheduled/tickets`,
    goLiveFilterDropDown: `${baseUrl}/api/v1/maintenance/site/filters`,
    pmSitesFilters: `${baseUrl}/api/v1/maintenance/site/pm/filters`,
    pmTicketsFilters: `${baseUrl}/api/v1/maintenance/site/pm/tickets/filters`,
    rmTicketsFilters: `${baseUrl}/api/v1/maintenance/site/rm/tickets/software-filters`,
    rmSoftwareTicketsFilters: `${baseUrl}/api/v1/maintenance/site/rm/tickets/filters`,
    rmHardwareTicketsFilters: `${baseUrl}/api/v1/maintenance/site/rm/tickets/hardware-filters`,
    emSitesFilters: `${baseUrl}/api/v1/employee/tickets/filters`,
    fetchCategoryList: `${baseUrl}/api/v1/maintenance/fetchCategory`,
    fetchMaintenanceCategoryType: `${baseUrl}/api/v1/maintenance/fetchMaintenanceCategoryType`,
    changeSiteStateToEnableOrDisable: `${baseUrl}/api/v1/maintenance/make-site-enable-disable`,
    getSiteStateToEnableOrDisable: `${baseUrl}/api/v1/maintenance/get-site-enable-disable`,
    getPmSiteStateList: `${baseUrl}/api/v1/maintenance/get-site-pm-state-list`,
    updatePmSiteState: `${baseUrl}/api/v1/maintenance/update-site-pm-state`,
    getEquipment: `${baseUrl}/api/v1/maintenance/rm/getEquipment`,
    getComponants: `${baseUrl}/api/v1/maintenance/rm/getComponants`,
    getLevels: `${baseUrl}/api/v1/maintenance/rm/getLevelData`,
    getLevelsDropdown: `${baseUrl}/api/v1/maintenance/rm/getLevelDropdowns`,
    rmCheckOut: `${goBaseUrl}/api/v1/maintenance/rm/rmCheckOut`,
    removeRcaItem: `${baseUrl}/api/v1/maintenance/rm/removeRcaItem`,
    fetchHotoList: `${baseUrl}/api/v1/maintenance/fetchHotoList`,
    getHotoAssigneeList: `${baseUrl}/api/v1/maintenance/hoto/getReportees`,
    updateHotoSiteAssignee: `${baseUrl}/api/v1/maintenance/hoto/change/assignee`,
    fetchHotoEngList: `${baseUrl}/api/v1/maintenance/fetchHotoEngList`,
    getHotoMaterialList: `${baseUrl}/api/v1/maintenance/hoto/getSiteHardware`,
    saveHotoMaintenance: `${baseUrl}/api/v1/maintenance/storeHotoMaintenance`,
    getHotoDetails: `${baseUrl}/api/v1/maintenance/getHotoDetails`,
    updateHotoStatus: `${baseUrl}/api/v1/maintenance/hoto/updateHotoStatus`,
    storeHotoInstallation: `${baseUrl}/api/v1/maintenance/storeHotoInstallation`,
    getAllHotoDetails: `${baseUrl}/api/v1/maintenance/getAllHotoDetails`,
    engineerList: `${baseUrl}/api/v1/maintenance/engineer-list`,
    pmSoftwareAnswer: `${baseUrl}/api/v1/maintenance/pm-software-mark-answer`,
    pmSoftwareSites: `${baseUrl}/api/v1/maintenance/pm-software-sites`,
    pmSoftwareUpdateAssignee: `${baseUrl}/api/v1/maintenance/update-pm-software-assignee`,
    pmSoftwareViewReport: `${baseUrl}/api/v1/maintenance/pm-software-site-view`,
    pmSoftwareRejected: `${baseUrl}/api/v1/maintenance/pm-software-reject`,
    pmSoftwareApproved: `${baseUrl}/api/v1/maintenance/pm-software-approve`,
    pmSoftwarePostMail: `${baseUrl}/api/v1/maintenance/pm-software-post-mail`,
    pmSoftwarePmDownload: `${baseUrl}/api/v1/maintenance/pm-software-site_download`,
    pmSoftwareFilter: `${baseUrl}/api/v1/maintenance/pm-software-filter`,
    fetchMaintenanceSites: `${baseUrl}/api/v1/maintenance/fetchMaintenanceSitesForServicePr`,
    fetchPrList: `${baseUrl}/api/v1/maintenance/fetchPrList`,
    fetchServicesAgainstPr: `${baseUrl}/api/v1/maintenance/fetchServicesAgainstPr`,
    saveServiceQuanity: `${baseUrl}/api/v1/maintenance/saveServiceQuanity`,
    getServiceQuantityConfirmation: `${baseUrl}/api/v1/maintenance/getServiceQuantityConfirmation`,
    fetchPrListPoGenerated: `${baseUrl}/api/v1/maintenance/fetchPrListPoGenerated`,
    getPrConfirmationDetails: `${baseUrl}/api/v1/maintenance/getPrConfirmationDetails`,
    viewRmListForSlotChange: `${baseUrl}/api/v1/maintenance/rm/viewReactiveMaintenanceForSlotChnage`,
    ticketChangeSlot: `${baseUrl}/api/v1/maintenance/rm/changeSlot`,
    fetchPmSlotDetails: `${baseUrl}/api/v1/maintenance/pm/pmSlotDetails`,
    fetchProjectPmSlotDetails: `${baseUrl}/api/v1/maintenance/pm/projectPmSlotDetails`,
    generateHappyCode: `${baseUrl}/api/v1/maintenance/rm/generateHappyCode`,
    generateHappyCodePM: `${baseUrl}/api/v1/maintenance/rm/generateHappyCodePM`,
    fetchMaintenancePMForProjects: `${baseUrl}/api/v1/maintenance/fetchMaintenancePMForProjects`,
  },

  notifications: {
    fetchUnread: `${baseUrl}/api/v1/notifications/fetchUnread`,
    fetchAll: `${baseUrl}/api/v1/notifications/fetchAll`,
  },
  editLead: {
    corporate: `${goBaseUrl}/api/v1/sales/lead/updateCorporate`,
    apartment: `${goBaseUrl}/api/v1/sales/lead/updateApartments`,
    b2bAlliance: `${baseUrl}/api/v1/sales/lead/updateAlliance`,
    supply: `${goBaseUrl}/api/v1/sales/lead/updateSupply`,
  },
  attendance: {
    attendanceList: `${baseUrl}/api/v1/attendance/fetchAttendanceList`,
    fetchAttd: `${baseUrl}/api/v1/attendance/fetchAttd`,
    attendanceOfficeList: `${baseUrl}/api/v1/attendance/fetchAttendanceOfficeList`,
    attendanceSiteList: `${baseUrl}/api/v1/attendance/fetchAttendanceSiteList`,
    storeEmployeeAttendanceData: `${baseUrl}/api/v1/attendance/storeEmployeeAttendanceData`,
    checkAttendance: `${goBaseUrl}/api/v1/darwin-work/check-attendance`,
    checkUserLocation: `${goBaseUrl}/api/v1/darwin-work/get-location-type`,
    markDarwinAttendance: `${goBaseUrl}/api/v1/darwin-work/mark-attendance`,
  },
  googleAPI: {
    placeSearch: `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places`,
    geocode: `https://maps.googleapis.com/maps/api/geocode/`,
    iosMapNavDir: `maps://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=`,
    AndroidMapNavDir: `https://www.google.com/maps/dir/?api=1&travelmode=driving&layer=traffic&destination=`,
  },
  tickets: {
    getTicketDetails: `${baseUrl}/api/v1/ticket/fetchTicketDataById?ticket_id=`,
    getTicketsList: `${baseUrl}/api/v1/ticket/fetchTicketData`,
    getSearchUser: `${goBaseUrl}/api/v1/getUserList`,
    createTicket: `${baseUrl}/api/v1/ticket/storeTicketData`,
    replyOnTicket: `${baseUrl}/api/v1/ticket/updateReplyOfTicketByUserId`,
    statusList: `${baseUrl}/api/v1/ticket/fetchTicketStatusData`,
    updateStatus: `${baseUrl}/api/v1/ticket/updateStatusByTicketId`,
    userRoleDropdown: `${baseUrl}/api/v1/user-dropdown-role-based`,
    saveExternalUser: `${baseUrl}/api/v1/save-external-user`,
    externalUsersList: `${baseUrl}/api/v1/external-users-listing`,
  },
  fileComplain: {
    siteTypes: `${goBaseUrl}/api/v1/sales/lead/types`,
    siteSearch: `${baseUrl}/api/v1/installation/site/search`,
    dropdownsData: `${baseUrl}/api/v1/maintenance/addComplainData`,
    complainRaised: `${baseUrl}/api/v1/maintenance/addComplain`,
    fetchComplain: `${baseUrl}/api/v1/maintenance/fetchComplain`,
    fetchAllIssue: `${baseUrl}/api/v1/maintenance/fetch-issue-listing`,
    viewComaplain: `${baseUrl}/api/v1/maintenance/viewComplain`,
    getSubIssueDropDown: `${goBaseUrl}/api/v1/maintenance/issue-subtype`,
    duplicateComplainData: `${baseUrl}/api/v1/maintenance/duplicate-ticket-data`,
    closeDuplicateComplaint: `${baseUrl}/api/v1/maintenance/close-duplicate-complains`,
    complainRaisedTicket: `${baseUrl}/api/v1/maintenance/complainRaisedTicket`,
    saveAssigneeTicket: `${baseUrl}/api/v1/maintenance/save-assignee-ticket`,
    saveComplaintReply: `${baseUrl}/api/v1/maintenance/saveComplaintReply`,
    closeComplain: `${baseUrl}/api/v1/maintenance/closeComplain`,
    reopenComplain: `${baseUrl}/api/v1/maintenance/reopenComplain`,
    getTroubleshoot: `${baseUrl}/api/v1/maintenance/troubleshoot/view`,
    postTroubleshoot: `${baseUrl}/api/v1/maintenance/troubleshoot/save/answer`,
    listFdTickets: `${baseUrl}/api/v1/maintenance/listFdTickets`,
    createFdTickets: `${baseUrl}/api/v1/maintenance/createFdTickets`,
    viewFdTicketDetails: `${baseUrl}/api/v1/maintenance/viewFdTicket`,
    getComplains: `${baseUrl}/api/v1/maintenance/getComplainList`,
    updateComplain: `${baseUrl}/api/v1/maintenance/updateComplain`,
    fetchComplainSupport: `${goBaseUrl}/api/v1/maintenance/fetchComplainSupport`,
    saveComplaintReplySupport: `${goBaseUrl}/api/v1/maintenance/saveComplaintReplySupport`,
    saveIssueReply: `${goBaseUrl}/api/v1/maintenance/save-issue-reply`,
    getCategoryCX: `${baseUrl}/api/v1/maintenance/getCategoryCX`,
    setCategoryCX: `${baseUrl}/api/v1/maintenance/setCategoryCX`,
    centralTechComplain: `${goBaseUrl}/api/v1/maintenance/complain-to-central-tech`,
    centralTechComplainList: `${goBaseUrl}/api/v1/maintenance/get-central-tech`,
    centralTechList: `${goBaseUrl}/api/v1/maintenance/all-central-tech`,
    changeCentralTech: `${goBaseUrl}/api/v1/maintenance/change-central-tech`,
    saveCteComplainRemarks: `${goBaseUrl}/api/v1/maintenance/save-cte-remarks`,
    fetchFaqs: `${baseUrl}/api/v1/maintenance/faqss`,
    fetchTicketCategory: `${baseUrl}/api/v1/maintenance/ticketCategory`,
    updateComplainCategory: `${baseUrl}/api/v1/maintenance/updateComplainCategory`,
    cteIssueListing: `${goBaseUrl}/api/v1/maintenance/fetch-cte-issue-listing`,
  },
  sitesLocMap: {
    getSitesLocMap: `${baseUrl}/api/v1/installation/site/fetchSitesLocationMap`,
  },
  employeeTickets: {
    createTicket: `${baseUrl}/api/v1/employee/addTicket`,
  },
  assesment: {
    levelsByRoleId: `${baseUrl}/api/v1/assesment/roleLevelAssesment`,
    getResources: `${baseUrl}/api/v1/assesment/getLevelResources`,
    questionsByRoleAndLevel: `${baseUrl}/api/v1/assesment/questionsByRoleAndLevel`,
    submitAssessmentTest: `${baseUrl}/api/v1/assesment/submitAssessmentTest`,
    getAssessmentHistory: `${baseUrl}/api/v1/assesment/getAssessmentHistory`,
    getMasterAssessmentHistory: `${baseUrl}/api/v1/assesment/getMasterAssessmentHistory`,
  },
  brandActivation: {
    getCSV: `${baseUrl}/api/v1/brandactivation/dashboard/getCSV`,
    getLateFee: `${baseUrl}/api/v1/brandactivation/dashboard/getLateFee`,
    setInstallmentFee: `${baseUrl}/api/v1/brandactivation/dashboard/setInstallmentFee`,
    dashboardSiteListing: `${baseUrl}/api/v1/brandactivation/dashboard/siteList`,
    dashboardInvoiceListing: `${baseUrl}/api/v1/brandactivation/dashboard/invoiceList`,
    dashboardSetInvoiceData: `${baseUrl}/api/v1/brandactivation/dashboard/setInvoiceData`,
    sitesListing: `${baseUrl}/api/v1/brandactivation/site/siteList`,
    siteMaintenance: `${baseUrl}/api/v1/installation/site/siteMaintenanceList`,
    siteFilters: `${baseUrl}/api/v1/brandactivation/site/filters`,
    sitePocAdd: `${baseUrl}/api/v1/brandactivation/site/poc/add`,
    sitePocList: `${baseUrl}/api/v1/brandactivation/site/poc/list`,
    sitePocUpdate: `${baseUrl}/api/v1/brandactivation/site/poc/update`,
    viewdetails: `${baseUrl}/api/v1/brandactivation/site/view`,
    giveRating: `${baseUrl}/api/v1/brandactivation/site/updateRating`,
    getRating: `${baseUrl}/api/v1/brandactivation/site/getRating`,
    meetingList: `${baseUrl}/api/v1/brandactivation/site/meeting/fetch`,
    meetingLists: `${baseUrl}/api/v1/brandactivation/site/meeting/meetings`,
    usersListForHod: `${baseUrl}/api/v1/brandactivation/site/meeting/fetch-users-list-for-hod`,
    saveUserRatingByHod: `${baseUrl}/api/v1/brandactivation/site/meeting/save-users-rating-by-hod`,
    getUserDataByUserId: `${baseUrl}/api/v1/brandactivation/site/meeting/get-user-data-by-user-id`,
    getJuniorListForImmediateSenior: `${baseUrl}/api/v1/brandactivation/site/meeting/get-junior-list-for-immediate-senior`,
    saveMeetingRatingBySenior: `${baseUrl}/api/v1/brandactivation/site/meeting/save-meeting-rating-by-senior`,
    emailDropdownForRating: `${baseUrl}/api/v1/brandactivation/site/meeting/get-email-dropdown`,
    selfScorecardByHod: `${baseUrl}/api/v1/brandactivation/site/meeting/self-score-hod-details`,
    selfScorecardBySenior: `${baseUrl}/api/v1/brandactivation/site/meeting/self-score-senior-details`,
    getFeedback: `${baseUrl}/api/v1/brandactivation/site/getFeedback`,
    feedbackById: `${baseUrl}/api/v1/brandactivation/site/getFeedbackById`,
    createMeeting: `${baseUrl}/api/v1/brandactivation/site/meeting/add`,
    saveMeetingAsDraft: `${baseUrl}/api/v1/brandactivation/site/meeting/save-as-draft`,
    saveMeetingCheckIn: `${baseUrl}/api/v1/brandactivation/site/meeting/save-check-in`,
    meetingDraftList: `${baseUrl}/api/v1/brandactivation/site/meeting/get-draft-data`,
    discardMeetingDraft: `${baseUrl}/api/v1/brandactivation/site/meeting/discard-draft`,
    updateMeeting: `${baseUrl}/api/v1/brandactivation/site/meeting/update`,
    createCampagin: `${baseUrl}/api/v1/brandactivation/create-ads-campaign`,
    campaginData: `${baseUrl}/api/v1/brandactivation/get-campaign-list`,
    updateCampaginStatus: `${baseUrl}/api/v1/brandactivation/update-campaign-status`,
    invoiceCreationCampaign: `${baseUrl}/api/v1/brandactivation/create-invoice-campaign`,
    meetingById: `${baseUrl}/api/v1/brandactivation/site/meeting/view`,
    meetingPoc: `${baseUrl}/api/v1/brandactivation/site/meeting/poc`,
    cancelMeeting: `${baseUrl}/api/v1/brandactivation/site/meeting/cancel`,
    completeMeeting: `${baseUrl}/api/v1/brandactivation/site/meeting/complete`,
    meetingMomAdd: `${baseUrl}/api/v1/brandactivation/site/mom/add`,
    meetingMomView: `${baseUrl}/api/v1/brandactivation/site/mom/view`,
    conductCampListing: `${baseUrl}/api/v1/brandactivation/site/camp/list`,
    createCamp: `${baseUrl}/api/v1/brandactivation/site/camp/create`,
    viewCamp: `${baseUrl}/api/v1/brandactivation/site/camp/view`,
    campMom: `${baseUrl}/api/v1/brandactivation/site/camp/mom/create`,
    campMomView: `${baseUrl}/api/v1/brandactivation/site/camp/mom/view`,
    getVendor: `${baseUrl}/api/v1/brandactivation/site/getVendors`,
    postVendor: `${baseUrl}/api/v1/brandactivation/site/vendor/add`,
    viewVendor: `${baseUrl}/api/v1/brandactivation/site/vendor/details`,
    getCorporateClient: `${baseUrl}/api/v1/brandactivation/site/corporate/clients`,
    addCorporateClient: `${baseUrl}/api/v1/brandactivation/site/client/add`,
    corporateClientPocList: `${baseUrl}/api/v1/brandactivation/site/corporate/client/poc`,
    addcorporateClientPoc: `${baseUrl}/api/v1/brandactivation/site/client/poc/add`,
    invoiceList: `${reconApiBase}/v1/kellton-crm/invoice/list`,
    addPayment: `${reconApiBase}/v1/kellton-crm/invoice/add-payment/`,
    deleteClient: `${baseUrl}/api/v1/brandactivation/site/corporate/client/delete`,
    updateClient: `${baseUrl}/api/v1/brandactivation/site/corporate/client/update`,
    clientPocAdd: `${baseUrl}/api/v1/brandactivation/site/client/poc/add`,
    clientPocUpdate: `${baseUrl}/api/v1/brandactivation/site/client/poc/update`,
    getClientPocById: `${baseUrl}/api/v1/brandactivation/site/client/poc/view`,
    fetchPreCampQues: `${baseUrl}/api/v1/brandactivation/site/camp/checklist`,
    postCampTraining: `${baseUrl}/api/v1/brandactivation/site/training/add`,
    postPreCampAns: `${baseUrl}/api/v1/brandactivation/site/post/answer`,
    campApprove: `${baseUrl}/api/v1/brandactivation/site/camp/approve`,
    updateCampStatus: `${baseUrl}/api/v1/brandactivation/site/camp/view/updateStatus`,
    campReject: `${baseUrl}/api/v1/brandactivation/site/camp/reject`,
    campApprovalList: `${baseUrl}/api/v1/brandactivation/site/camp/approval/pending/list`,
    baReportees: `${baseUrl}/api/v1/brandactivation/site/reportees`,
    baMaintenanceReportees: `${baseUrl}/api/v1/brandactivation/site/maintenance-reportees`,
    baChangeAssignee: `${baseUrl}/api/v1/brandactivation/site/assign`,
    smAssign: `${baseUrl}/api/v1/brandactivation/site/maintenance-assign`,
    getInfraId: `${baseUrl}/api/v1/brandactivation/site/carnival/getInfraId`,
    saveCarnival: `${baseUrl}/api/v1/brandactivation/site/carnival/saveCarnival`,
    carnivalListing: `${baseUrl}/api/v1/brandactivation/site/carnival/list`,
    viewCarnival: `${baseUrl}/api/v1/brandactivation/site/carnival/view`,
    getCarnivalData: `${baseUrl}/api/v1/brandactivation/site/carnival/getCarnivalData`,
    createDuplicateCarnival: `${baseUrl}/api/v1/brandactivation/site/carnival/createDuplicateCarnival`,
    updateCarnivalStatus: `${baseUrl}/api/v1/brandactivation/site/carnival/updateCarnivalStatus`,
    updateCarnivalData: `${baseUrl}/api/v1/brandactivation/site/carnival/updateCarnivalData`,
    saveNormalCarnival: `${baseUrl}/api/v1/brandactivation/site/carnival/saveNormalCarnival`,
    normalCarnivalListing: `${baseUrl}/api/v1/brandactivation/site/carnival/normal-onboarding-listing`,
    updateNormalCarnival: `${baseUrl}/api/v1/brandactivation/site/carnival/normal-onboarding-update`,
    getNormalCarnival: `${baseUrl}/api/v1/brandactivation/site/carnival/get-normal-onboarding`,
    getEmailClient: `${baseUrl}/api/v1/brandactivation/site/carnival/get-client-email`,
    meetingMomSend: `${baseUrl}/api/v1/brandactivation/site/carnival/create-mom-send`,
    getMomList: `${baseUrl}/api/v1/brandactivation/site/carnival/mom-listing`,
    getprojectOnboardingList: `${goBaseUrl}/api/v1/sales/lead/project-onboarding-list`,
    getSolution: `${baseUrl}/api/v1/sales/lead/get-solution`,
    getMaterialPrice: `${baseUrl}/api/v1/sales/lead/get-material-price`,
    setQuotation: `${baseUrl}/api/v1/sales/lead/set-quotation`,
    getAllQuotations: `${baseUrl}/api/v1/sales/lead/get-all-quotations`,
    getQuotation: `${baseUrl}/api/v1/sales/lead/get-quotation`,
    quotationStatusChange: `${baseUrl}/api/v1/sales/lead/quotation-status-change`,
    quotationHistory: `${baseUrl}/api/v1/sales/lead/quotation-history`,
    getContractDataForRenewal: `${goBaseUrl}/api/v1/sales/lead/getContractDataForRenewal`,
    renewalSaveData: `${goBaseUrl}/api/v1/sales/lead/renewalSaveData`,
    getRenewalApprovalList: `${goBaseUrl}/api/v1/sales/lead/getRenewalApprovalList`,
    acceptRenewalApproval: `${goBaseUrl}/api/v1/sales/lead/acceptRenewalApproval`,
    getInvoiceDetails: `${goBaseUrl}/api/v1/sales/lead/get-invoice-details`,
    rejectRenewalApproval: `${goBaseUrl}/api/v1/sales/lead/rejectRenewalApproval`,
    getRenewalListing: `${baseUrl}/api/v1/brandactivation/site/renewalList`,
    renewalSaveEditData: `${goBaseUrl}/api/v1/sales/lead/renewalSaveEditData`,
    helpdeskListing: `${baseUrl}/api/v1/brandactivation/site/helpdesk/list`,
    saveHelpdesk: `${baseUrl}/api/v1/brandactivation/site/helpdesk/saveHelpdesk`,
    viewHelpdesk: `${baseUrl}/api/v1/brandactivation/site/helpdesk/view`,
    getHelpdeskData: `${baseUrl}/api/v1/brandactivation/site/getHelpdeskData`,
    updateHelpdeskData: `${baseUrl}/api/v1/brandactivation/site/updateHelpdeskData`,
    updateHelpdeskStatus: `${baseUrl}/api/v1/brandactivation/site/updateHelpdeskStatus`,
    createDuplicateHelpdesk: `${baseUrl}/api/v1/brandactivation/site/createDuplicateHelpdesk`,
    getprojectOnboardingListForFinance: `${goBaseUrl}/api/v1/sales/lead/project-onboarding-list-finance`,
    getFlatFiles: `${baseUrl}/api/v1/brandactivation/site/getFlatFilesBySite`,
    savePoc: `${baseUrl}/api/v1/brandactivation/savePoc`,
    getInvoicesMappedToSite: `${baseUrl}/api/v1/brandactivation/mappedInvoicesToSite`,
    getChequePickedList: `${baseUrl}/api/v1/brandactivation/getChequePickedList`,
    dispatchCheque: `${baseUrl}/api/v1/brandactivation/dispatchCheque`,
    getTransactionAmountFromUncliamed: `${baseUrl}/api/v1/sales/listUnclaimedTrans`,
    getBusinessList: `${baseUrl}/api/v1/brandactivation/ba-business_list`,
    helperDetails: {
      listing: `${baseUrl}/api/v1/brandactivation/helper-details-list`,
      add: `${baseUrl}/api/v1/brandactivation/save-helper-details`,
      getById: `${baseUrl}/api/v1/brandactivation/helper-details-by-id`,
    },
    getClientAddressDetails: `${goBaseUrl}/api/v1/sales/client/fetchClientAddress`,
    getBusinessAddressDetails: `${goBaseUrl}/api/v1/sales/business/fetchBusinessAddress`,
    baOpportunityListFromLeadx: `${baseUrl}/api/v1/lead-squared/ba-opportunity`,
    uploadMeetingPlan: `${baseUrl}/api/v1/brandactivation/site/meeting-plan-upload`,
    fetchUploadMeetingPlan: `${baseUrl}/api/v1/brandactivation/site/fetch-meeting-plan-upload`,
    planListingDetails: `${baseUrl}/api/v1/brandactivation/site/meeting-plan-details`,
    getNcsMeetings: `${baseUrl}/api/v1/brandactivation/site/meeting/get-ncs-meetings`,
    getNcsMeetingbyId: `${baseUrl}/api/v1/brandactivation/site/meeting/get-ncs-meeting-by-id`,
    saveAndCheckoutNCSMeeting: `${baseUrl}/api/v1/brandactivation/site/meeting/checkout-ncs-meeting`,
    saveAndCheckInNCSMeeting: `${baseUrl}/api/v1/brandactivation/site/meeting/checkin-ncs-meeting`,
    invoicesBySiteNumber: `${baseUrl}/api/v1/brandactivation/dashboard/invoiceListBySiteNumber`,
    getClientOrdersList: `${baseUrl}/api/v1/brandactivation/site/client-orders`,
  },
  products: {
    fetchProductsList: `${baseUrl}/api/v1/product/fetchProduct`,
    fetchProduct: `${baseUrl}/api/v1/product/productDetails`,
    checkoutOrder: `${baseUrl}/api/v1/product/postSiteOrderProduct`,
    sitesList: `${baseUrl}/api/v1/installation/site/allSiteIdAndName`,
  },
  knowledgeCenter: {
    fetchKnowledgeCenter: `${baseUrl}/api/v1/knowledgeCenter/fetchKnowledgeCenter`,
  },
  client: {
    fetchBillingAddress: `${goBaseUrl}/api/v1/sales/fetchBillingAddressPoc?client_id=`,
    fetchBillingGST: `${goBaseUrl}/api/v1/sales/fetchBillingGst`,
    getClientByPan: `${goBaseUrl}/api/v1/client/getClientByPan`,
    getDetailsByGst: `${goBaseUrl}/api/v1/client/getGstDetails`,
  },

  rcTransfer: {
    getRcTransferList: `${baseUrl}/api/v1/fusion-dashboard/rc-transfer-listing`,
    statusUpdateRcTransfer: `${baseUrl}/api/v1/fusion-dashboard/rc-transfer-status-update`,
  },

  valet: {
    infraZone: `${baseUrl}/api/v1/sales/fusion-dashboard/infra-zone`,
    supervisor: `${baseUrl}/api/v1/sales/fusion-dashboard/supervisor`,
    supervisorList: `${baseUrl}/api/v1/sales/fusion-dashboard/supervisorList`,
    valetList: `${baseUrl}/api/v1/sales/fusion-dashboard/valetList`,
    getValetListData: `${baseUrl}/api/v1/sales/fusion-dashboard/get-all-valet-list`,
    updateValetListData: `${baseUrl}/api/v1/sales/fusion-dashboard/update-data-for-valet`,
    updateValetSalary: `${baseUrl}/api/v1/sales/fusion-dashboard/update-salary-for-valet`,
    getSupervisorListData: `${baseUrl}/api/v1/sales/fusion-dashboard/get-all-supervisor-list`,
    updateSupervisorListData: `${baseUrl}/api/v1/sales/fusion-dashboard/update-data-for-supervisor`,
    addValet: `${baseUrl}/api/v1/sales/fusion-dashboard/add-valet`,
    project: `${baseUrl}/api/v1/sales/fusion-dashboard/add-project`,
    searchProject: `${baseUrl}/api/v1/sales/fusion-dashboard/search-project`,
    incentiveSlab: `${baseUrl}/api/v1/sales/fusion-dashboard/incentive-slab`,
    updateValetStatus: `${baseUrl}/api/v1/sales/fusion-dashboard/delete-valet`,
    deleteSupervisor: `${baseUrl}/api/v1/sales/fusion-dashboard/delete-supervisor`,
    zoneList: `${baseUrl}/api/v1/sales/fusion-dashboard/zone-list`,
    updateProject: `${baseUrl}/api/v1/sales/fusion-dashboard/update-project`,
    projectPricing: `${baseUrl}/api/v1/sales/fusion-dashboard/get-project-price`,
    getInfraId: `${baseUrl}/api/v1/sales/fusion-dashboard/get-valet-id`,
    getMonthlyData: `${baseUrl}/api/v1/sales/fusion-dashboard/valet-monthly-data`,
    dailySalaryDistribution: `${baseUrl}/api/v1/sales/fusion-dashboard/daily-salary-distribution`,
    calculateValetSalary: `${baseUrl}/api/v1/sales/fusion-dashboard/calculate-valet-salary`,
    markHolidays: `${baseUrl}/api/v1/sales/fusion-dashboard/mark-holidays`,
    getAllRaisedTicketsForValet: `${baseUrl}/api/v1/sales/fusion-dashboard/get-all-raised-tickets`,
    respondedByValetOps: `${baseUrl}/api/v1/sales/fusion-dashboard/respond-by-valet-ops`,
    statusUpdateByValetHead: `${baseUrl}/api/v1/sales/fusion-dashboard/status-update-by-valet-head`,
    updateSalaryStatus: `${baseUrl}/api/v1/sales/fusion-dashboard/update-salary-status`,
    releaseSalary: `${baseUrl}/api/v1/sales/fusion-dashboard/release-salary`,
    tagCreation: `${baseUrl}/api/v1/sales/fusion-dashboard/create-tag`,
    tagList: `${baseUrl}/api/v1/sales/fusion-dashboard/tag-list`,
    getContacts: `${baseUrl}/api/v1/sales/fusion-dashboard/valet-contacts`,
    getProjects: `${baseUrl}/api/v1/sales/fusion-dashboard/projects`,
    broadcastNotification: `${baseUrl}/api/v1/sales/fusion-dashboard/broadcast-notifications`,
    getEventSalary: `${baseUrl}/api/v1/sales/fusion-dashboard/event-salary`,
    approveEventSalary: `${baseUrl}/api/v1/sales/fusion-dashboard/approve-event-salary`,
    getPenaltyList: `${baseUrl}/api/v1/sales/fusion-dashboard/penalty-grid`,
    masterSalaryPenalty: `${baseUrl}/api/v1/sales/fusion-dashboard/salary-penalty`,
    masterSalaryPenaltyLis: `${baseUrl}/api/v1/sales/fusion-dashboard/salary-penalty-list`,
    salaryByPhoneNo: `${baseUrl}/api/v1/sales/fusion-dashboard/salary-by-phone-no`,
    userNotificationList: `${baseUrl}/api/v1/sales/fusion-dashboard/user-notification-list`,
    fetchAttendanceRequests: `${baseUrl}/api/v1/sales/fusion-dashboard/fetch-attendance-requests`,
    getAllDays: `${baseUrl}/api/v1/sales/fusion-dashboard/get-all-days`,
    valetAttendanceRequest: `${baseUrl}/api/v1/sales/fusion-dashboard/valetAttendanceRequest`,
    allValetUsers: `${baseUrl}/api/v1/sales/fusion-dashboard/all-valet-users`,
    advanceSalaryList: `${baseUrl}/api/v1/sales/fusion-dashboard/advance-salary/list`,
    advanceSalaryCalculate: `${baseUrl}/api/v1/sales/fusion-dashboard/advanced-salary/calculate`,
    advanceSalaryUpdate: `${baseUrl}/api/v1/sales/fusion-dashboard/advanced-salary/update`,
  },
  distanceCalculator: {
    siteData: `${baseUrl}/api/v1/installation/site/get-site`,
    calculateDistance: `${goBaseUrl}/api/v1/installation/site/site-to-eng-distance-calculator`,
    distanceCalculateData: `${goBaseUrl}/api/v1/installation/site/get-site-to-eng-distance-calculator`,
    distanceCalculateDataAtt: `${baseUrl}/api/v1/installation/site/site-to-eng-distance-calculator-att`,
  },

  BulkAssignment: {
    assignedTo: `${baseUrl}/api/v1/brandactivation/site/bulk-assignment/assign-to`,
    repotee: `${baseUrl}/api/v1/brandactivation/site/bulk-assignment/repotees`,
    search: `${baseUrl}/api/v1/brandactivation/site/bulk-assignment/search`,
    newAssignee: `${baseUrl}/api/v1/brandactivation/site/bulk-assignment/new-assign`,
    uploadcsvfile: `${baseUrl}/api/v1/brandactivation/site/bulk-assignment/uploadcsv`,
  },
  networkEngineer: {
    createTask: `${goBaseUrl}/api/v1/network-eng/task`, // migrated to fusion-backend-go (ops/site_visit)
    taskList: `${goBaseUrl}/api/v1/network-eng/get-task`, // migrated to fusion-backend-go (ops/site_visit)
  },
  siteVisit: {
    createTask: `${goBaseUrl}/api/v1/site-visit/save`, // migrated to fusion-backend-go (ops/site_visit)
    taskList: `${goBaseUrl}/api/v1/site-visit/get-list`, // migrated to fusion-backend-go (ops/site_visit)
    getById: `${goBaseUrl}/api/v1/site-visit/get-by-id`, // migrated to fusion-backend-go (ops/site_visit)
  },
  materialRequistionForm: {
    getSiteDetails: `${goBaseUrl}/api/v1/procurement/get-sites`,
    siteDetailsBySiteNo: `${baseUrl}/api/v1/procurement/site-details`,
    material: `${baseUrl}/api/v1/procurement/material-details`,
    getCategoryData: `${baseUrl}/api/v1/procurement/getCategoryData`,
    associateMaterial: `${baseUrl}/api/v1/procurement/material-associate`,
    save: `${baseUrl}/api/v1/procurement/save-material`,
    materialTypes: `${baseUrl}/api/v1/procurement/material-types`,
    reportee: `${baseUrl}/api/v1/procurement/get-repotee`,
    warehouse: `${baseUrl}/api/v1/procurement/get-warehouse-address`,
    pendingMaterial: `${baseUrl}/api/v1/procurement/pending-material`,
    fetchSalesOrderReturnMrf: `${baseUrl}/api/v1/procurement/fetch-sales-order-return-mrf`,
    fetchSalesOrderReturnMrfDetails: `${baseUrl}/api/v1/procurement/fetch-sales-order-return-mrf-detail`,
    sendSalesReturnToErp: `${baseUrl}/api/v1/procurement/send-sales-return-to-erp`,
    ViewMaterial: `${baseUrl}/api/v1/procurement/view-material`,
    approval: `${baseUrl}/api/v1/procurement/material-approval`,
    creditLimitListing: `${baseUrl}/api/v1/procurement/credit-limit-ledger`,
    toEmployee: `${baseUrl}/api/v1/procurement/to-employee`,
    storeAddress: `${baseUrl}/api/v1/procurement/store-address`,
    empMrfListing: `${baseUrl}/api/v1/procurement/view-emp-mrf`,
    getChallans: `${baseUrl}/api/v1/procurement/getChallans`,
    getChallanItems: `${baseUrl}/api/v1/procurement/getChallanItems`,
    saveMaterialReceive: `${baseUrl}/api/v1/procurement/saveMaterialReceive`,
    empMrfMaterial:`${baseUrl}/api/v1/procurement/fetchEmpMrfMaterial`,
    saveEmpMrfSerialNo:`${baseUrl}/api/v1/procurement/saveEmpMrfSerialNo`,
    userCreditLimit:`${baseUrl}/api/v1/procurement/increase-user-credit-limit`,
    getUserCreditLimit:`${baseUrl}/api/v1/procurement/get-user-credit-limit`,
    fetchMrfListing:`${baseUrl}/api/v1/procurement/get-mrf-list`,
    showMrfView:`${baseUrl}/api/v1/procurement/show-mrf-view`,
    mrfTypeDropdown:`${baseUrl}/api/v1/procurement/mrf-type-dropdown`,
    getMrfTypeList:`${baseUrl}/api/v2/procurement/getMrfTypeList`,
    getMrfTypeDropdownData:`${baseUrl}/api/v2/procurement/getMrfTypeDropdownData`,
    createMrfType:`${baseUrl}/api/v2/procurement/createMrfType`,
    editMrfType:`${baseUrl}/api/v2/procurement/editMrfType`,
    deleteMrfType:`${baseUrl}/api/v2/procurement/deleteMrfType`,
  },

  wallet: {
    list: `${baseUrl}/api/v1/wallet/list`,
    transaction: `${baseUrl}/api/v1/wallet/transaction`,
    approvalList: `${baseUrl}/api/v1/wallet/all-request`,
    requestListing: `${baseUrl}/api/v1/wallet/request-listing`,
    requestApprovalList: `${baseUrl}/api/v1/wallet/all-request-approval`,
    addMoney: `${baseUrl}/api/v1/wallet/add-money-request`,
    walletFinanceRequest: `${baseUrl}/api/v1/wallet/wallet-finance-request`,
    approveOrRejectWalletTransaction: `${baseUrl}/api/v1/wallet/wallet-transaction-approval`,
    downlaodWalletTransaction: `${baseUrl}/api/v1/wallet/download-wallet-transaction`,
    viewRequest: `${baseUrl}/api/v1/wallet/view-request`,
    requesttransactionList: `${baseUrl}/api/v1/wallet/request-transactions`,
    requestInternalWalletListing: `${baseUrl}/api/v1/wallet/internal-wallet-request-list`,
    walletRequestList: `${baseUrl}/api/v1/wallet/wallet-request-list`,
    fecthDealerData: `${baseUrl}/api/v1/wallet/fecth-dealer-data`,
    addPaymentForDealer: `${baseUrl}/api/v1/wallet/add-dealer-payment`,
    listDealerRequest: `${baseUrl}/api/v1/wallet/listDealerRequest`,
    listDealerRequestApproval: `${baseUrl}/api/v1/wallet/listDealerRequestApproval`,
    walletApprovalFinance: `${baseUrl}/api/v1/wallet/walletApprovalFinance`,
    approveOrReject: `${baseUrl}/api/v1/wallet/approveOrRejectRequest`,
  },
  erp: {
    erpInventory: `${baseUrl}/api/v1/getInventory`,
  },
  contractAssetsMapping: {
    contractList: `${goBaseUrl}/api/v1/installation/contract-list`, // migrated to fusion-backend-go
    gateList: `${goBaseUrl}/api/v1/installation/contract-gate`, // migrated to fusion-backend-go
    materialList: `${goBaseUrl}/api/v1/installation/contract-gate-material`, // migrated to fusion-backend-go
    barcodeHistory: `${baseUrl}/api/v1/installation/barcode-history`, // migrated to fusion-backend-go
    siteAssetsVerification: `${baseUrl}/api/v1/installation/site-assets-verification`,
  },
  helpdeskUser: {
    userHelpdeskListing: `${baseUrl}/api/v1/help-desk/get-config-user-list`,
    userDropdown: `${baseUrl}/api/v1/help-desk/get-user-list`,
    approvalDropdown: `${baseUrl}/api/v1/help-desk/get-senior-list`,
    saveUserConfig: `${baseUrl}/api/v1/help-desk/save-user-config`,
    updateUserConfig: `${baseUrl}/api/v1/help-desk/user-config-update`,
    getAutofillData: `${baseUrl}/api/v1/help-desk/get-autofill-data`,
    userConfigStatus: `${baseUrl}/api/v1/help-desk/user-config-status-update`,
    userRequest: `${baseUrl}/api/v1/help-desk/save-user-request`,
    useCases: `${baseUrl}/api/v1/help-desk/use-case-list`,
    userRequestList: `${baseUrl}/api/v1/help-desk/user-request-list`,
    approvalPendingList: `${baseUrl}/api/v1/help-desk/user-request-to-approval`,
    financeHierarchyList: `${baseUrl}/api/v1/help-desk/finance-hierarchy-listing`,
    RequestById: `${baseUrl}/api/v1/help-desk/user-request-by-id`,
    Approval: `${baseUrl}/api/v1/help-desk/user-approval`,
    backToModification: `${baseUrl}/api/v1/help-desk/back-to-modification`,
    backToModificationResponse: `${baseUrl}/api/v1/help-desk/modification-response`,
    requestFilterData: `${baseUrl}/api/v1/help-desk/request-filter`,
    userConfigListing: `${baseUrl}/api/v1/help-desk/get-configuration-user-list`,
    saveUserConfiguration: `${baseUrl}/api/v1/help-desk/save-user-configuration`,
    userConfigurationStatus: `${baseUrl}/api/v1/help-desk/user-configuration-status-update`,
    getAutofillUserData: `${baseUrl}/api/v1/help-desk/get-autofill-user-data`,
    backToModificationList: `${baseUrl}/api/v1/help-desk/modification-request`,
    csvDownload: `${baseUrl}/api/v1/help-desk/csv-download`,
    reconPiTiValidation: `${baseUrl}/api/v2/help-desk/recon-pi-ti-validation`,
  },
  ledgerBusiness: {
    ledgerList: `${baseUrl}/api/v1/sales/ledgerList`,
    ledgerDownload: `${baseUrl}/api/v1/sales/ledgerDownload`,
  },
  invoiceValidation: {
    list: `${baseUrl}/api/v1/sales/invoice-module/validation-list`,
    closeRequest: `${baseUrl}/api/v1/sales/invoice-module/close-request`,
  },
  imageCompression: {
    compressImage: `${baseUrl}/api/v1/fileUpload/compress-image`,
  },

  CarLoan: {
    ucdList: `${baseUrl}/api/v1/lead-squared/ucd-list`,
    ucdView: `${baseUrl}/api/v1/lead-squared/ucd-dealer-id`,
    newCase: `${baseUrl}/api/v1/lead-squared/ucd-cases`,
    b2cUpdateLoanApplication: `${baseUrl}/api/v1/lead-squared/update-loan-application`,
    b2cCaseLoginWithoutDealer: `${baseUrl}/api/v1/lead-squared/b2c-case-without-dealer`,
    caseListing: `${baseUrl}/api/v1/lead-squared/cases-list`,
    caseById: `${baseUrl}/api/v1/lead-squared/cases-by-id`,
    carBrand: `${baseUrl}/api/v1/lead-squared/car-brand`,
    carModel: `${baseUrl}/api/v1/lead-squared/car-model`,
    carVariant: `${baseUrl}/api/v1/lead-squared/car-variant`,
    carBrandForB2C: `${baseUrl}/api/v1/lead-squared/car-brand-for-b2c`,
    carModelForB2C: `${baseUrl}/api/v1/lead-squared/car-model-for-b2c`,
    bankList: `${baseUrl}/api/v1/lead-squared/bank-list`,
    caseByLsqDealerId: `${baseUrl}/api/v1/lead-squared/case-by-dealer-id`,
    updateCaseStatus: `${baseUrl}/api/v1/lead-squared/update-ucd-case-status`,
    loanApplicationById: `${baseUrl}/api/v1/lead-squared/loan-application-by-id`,
    loanApplicationUpdate: `${baseUrl}/api/v1/lead-squared/loan-application-update`,
    raisePayment: `${baseUrl}/api/v1/lead-squared/payment-raise`,
    loanAccount: `${baseUrl}/api/v1/lead-squared/loan-account-details`,
    loanUndertaking: `${baseUrl}/api/v1/lead-squared/loan-undertaking`,
    loanTranches: `${baseUrl}/api/v1/lead-squared/loan-tranches`,
    loanPaymentRequest: `${baseUrl}/api/v1/lead-squared/loan-payment-request`,
    updateTrancheStatus: `${baseUrl}/api/v1/lead-squared/loan-tranche-update-status`,
    raisePaymentUpdate: `${baseUrl}/api/v1/lead-squared/payment-raise-update`,
    accountPennyDrop: `${baseUrl}/api/v1/lead-squared/account-penny-drop`,
    approvalRequest: `${baseUrl}/api/v1/lead-squared/request-approval`,
    bankSheetUpload: `${baseUrl}/api/v1/lead-squared/bank-sheet-upload`,
    getThePayoutDetails: `${baseUrl}/api/v1/lead-squared/get-payout-details`,
    updateThePayoutDetails: `${baseUrl}/api/v1/lead-squared/payout-details-update`,
    getAccountDetailsForPayout: `${baseUrl}/api/v1/lead-squared/get-account-details-for-payout`,
    newBankDetails: `${baseUrl}/api/v1/lead-squared/ucd-v2-bank-list`,
    payoutConfigurationList: `${baseUrl}/api/v1/lead-squared/payout-configuration-list`,
    payoutConfigurationVerify: `${baseUrl}/api/v1/lead-squared/payout-configuration-verify`,
    b2cLeadList: `${baseUrl}/api/v1/lead-squared/b2c-lead-list`,
    foreClosureAccountDetails: `${baseUrl}/api/v1/lead-squared/fore-closure-account-details`,
    vehicleDetails: `${baseUrl}/api/v1/lead-squared/vehicle-details`,
    rcCaseList: `${baseUrl}/api/v1/lead-squared/rc-case-listing`,
    rcCaseById: `${baseUrl}/api/v1/lead-squared/rc-case-by-id`,
    rtoDetailsUpdate: `${baseUrl}/api/v1/lead-squared/rto-details-update`,
    commissionPayoutCasesList: `${baseUrl}/api/v1/lead-squared/commission-payout-case-list`,
    invoiceValidateStatus: `${baseUrl}/api/v1/lead-squared/invoice-validate-status`,
    previewInvoice: `${baseUrl}/api/v1/lead-squared/preview-invoice-against-cases`,
    raiseInvoiceWithRecon: `${baseUrl}/api/v1/lead-squared/raise-invoice-with-recon`,
  },
  contractRenewal: {
    getSiteList: `${baseUrl}/api/v1/contract-renewal/get-site-list`,
    getPrefilledGateData: `${baseUrl}/api/v1/contract-renewal/prefilled-gate-data`,
    saveRenewalRequest: `${baseUrl}/api/v1/contract-renewal/save-renewal-request`,
    getPrefilledRequest: `${baseUrl}/api/v1/contract-renewal/get-prefilled-request`,
    getRequestList: `${baseUrl}/api/v1/contract-renewal/renewal-request-list`,
    updateRequestStatus: `${baseUrl}/api/v1/contract-renewal/update-request-status`,
    getRequestDetails: `${baseUrl}/api/v1/contract-renewal/renewal-request-details`,
    getFilters: `${baseUrl}/api/v1/contract-renewal/get-filters`,
    getPreviousRequests: `${baseUrl}/api/v1/contract-renewal/get-raised-requests`,
    getGateBasePrices: `${baseUrl}/api/v1/contract-renewal/get-base-prices`,
    updateClientStatus: `${baseUrl}/api/v1/contract-renewal/update-client-status`,
    getClientRemarks: `${baseUrl}/api/v1/contract-renewal/get-client-remark-options`,
  },
  creditPolicy: {
    getCredits: `${baseUrl}/api/v1/creditPolicy/getCredits`,
    updateBusinessCredits: `${baseUrl}/api/v1/creditPolicy/updateBusinessCredits`,
    updateEmployeeCredits: `${baseUrl}/api/v1/creditPolicy/updateEmployeeCredit`,
    retagInvoice: `${baseUrl}/api/v1/creditPolicy/retagInvoice`,
    getEmployeeInvoiceListing: `${baseUrl}/api/v1/creditPolicy/getEmployeeInvoiceListing`,
    getEmployeeTeamList: `${baseUrl}/api/v1/creditPolicy/getEmployeeTeamList`,
  },
  offRoleEmployees: {
    getOffRoleEmployeesList: `${baseUrl}/api/v1/offrole/employee/management/fetch-offrole-employees`,
    fetchDropdownDatas: `${baseUrl}/api/v1/offrole/employee/management/fetch-dropdown-datas`,
    updateActionByBusinessHead: `${baseUrl}/api/v1/offrole/employee/management/update-action-by-business-head`,
    generateOnboardingLink: `${baseUrl}/api/v1/offrole/employee/management/generate-link-for-offrole_employees`,
    departmentDropdown: `${baseUrl}/api/v1/offrole/employee/management/department-dropdown`,
    teamDropdown: `${baseUrl}/api/v1/offrole/employee/management/teams-dropdown`,
    roleDropdown: `${baseUrl}/api/v1/offrole/employee/management/roles-dropdown`,
    reportingManagerDropdown: `${baseUrl}/api/v1/offrole/employee/management/reporting-manager-dropdown`,
    citiesDropdown: `${baseUrl}/api/v1/offrole/employee/management/cities-dropdown`,
    zonesDropdown: `${baseUrl}/api/v1/offrole/employee/management/zones-dropdown`,
    areasDropdown: `${baseUrl}/api/v1/offrole/employee/management/areas-dropdown`,
    assignLocations: `${baseUrl}/api/v1/offrole/employee/management/assign-locations`,
    assignReportee: `${baseUrl}/api/v1/offrole/employee/management/assign-reportee`,
    fetchUserLocationMapping: `${baseUrl}/api/v1/offrole/employee/management/fetch-user-location-mapping`,
    fetchUserTeamMapping: `${baseUrl}/api/v1/offrole/employee/management/fetch-user-team-mapping`,
    deleteUserMapping: `${baseUrl}/api/v1/offrole/employee/management/delete-user-mapping`,
  },
  businessItems:{
    createDeleteBrand:      `${baseUrl}/api/v1/procurement/createDeleteBrand`,
    createDeleteCategory:   `${baseUrl}/api/v1/procurement/createDeleteCategory`,
    getBrands:              `${baseUrl}/api/v1/procurement/getBrands`,
    getCategories:          `${baseUrl}/api/v1/procurement/getCategories`,
    createDeleteHSN:        `${baseUrl}/api/v1/procurement/createDeleteHSN`,
    getHsnListing:          `${baseUrl}/api/v1/procurement/getHsnListing`,
    getGstData:             `${baseUrl}/api/v1/procurement/getGstData`,
    getItemDropdownData:    `${baseUrl}/api/v1/procurement/getItemDropdownData`,
    fetchBrandAndHsn:       `${baseUrl}/api/v1/procurement/fetchBrandAndHsn`,
    getBusinessItemListing: `${baseUrl}/api/v1/procurement/getBusinessItemListing`,
    createMaterials:        `${baseUrl}/api/v1/procurement/createMaterials`,
    editMaterials:          `${baseUrl}/api/v1/procurement/editMaterials`,
    approveItem:            `${baseUrl}/api/v1/procurement/approveItem`
  },
  lob:{
    getLobListing      : `${goBaseUrl}/api/v1/lob/getLobListing`,
    createLob          : `${goBaseUrl}/api/v1/lob/createLob`,
    editLob            : `${goBaseUrl}/api/v1/lob/editLob`,
  },
  fastag: {
    uploadPricingRequest: `${fasTagUrl}/api/v1/fastag-issuance/internal/upload-pricing-request`,
    markinactive: `${fasTagUrl}/api/v2/fastag-issuance/ship-tag/mark-inactive`,
    transferTag: `${baseUrl}/api/v2/fastag/tag-transfer`,
    addCashback: `${fasTagUrl}/api/v1/fastag-issuance/operator-reward-campaign`,
    deleteCashback: `${fasTagUrl}/api/v1/fastag-issuance/operator-reward-campaign`,
    reAssignUser: `${fasTagUrl}/api/v1/fastag-issuance/toa/re-assign-user`,
    bundleApi: `${fasTagUrl}/api/v1/fastag-issuance/internal/package`,
    getToaTagOrders: `${fasTagUrl}/api/v1/fastag-issuance/toa/preorder/v2/order-listing`,
    approveTagOrder: `${fasTagUrl}/api/v1/fastag-issuance/toa/preorder/v2/order-status-update`,
    uploadTagOrderCsv: `${fasTagUrl}/api/v1/fastag-issuance/toa/preorder/v2/upload-csv`,
    getUserAnalytics: `${fasTagUrl}/api/v1/fastag-issuance/toa/preorder/v2/user-analytics`,
    removeSbiReplacementTags: `${fasTagUrl}/api/v1/fastag-issuance/internal/remove-sbi-replacement-tags-from-toa-inventory`,
    presignedUrlCreate: `${storageUrl}/api/v2/document/presigned-url/create`,
    presignedUrlComplete: `${storageUrl}/api/v2/document/presigned-url/upload`,
    bulkUploadKyV: `${fasTagUrl}/api/v1/fastag-issuance/internal/bulk-upload`,
    bulkUploadListing: `${fasTagUrl}/api/v1/fastag-issuance/internal/bulk-upload-listing`,
    validateBulkUploadRequest: `${fasTagUrl}/api/v1/fastag-issuance/internal/validate-bulk-upload-request`,
    fseBulkMapping: `${fasTagUrl}/api/v1/fastag-issuance/internal/fse-bulk-mapping`,
    sbiAgentPortalData: `${fasTagUrl}/api/v1/fastag-issuance/toa/sbi-agent-portal-data`,
  },
  user: {
    reportingHierarchy: `${goBaseUrl}/api/v1/user/reporting-hierarchy`,
    getUserDetailsByUserId: `${goBaseUrl}/api/v1/user/user-details-by-id`,
    userDevices: `${userServiceUrl}/api/user/monitor/user-devices`,
    deactivateUserDevice: (deviceId) =>
      `${userServiceUrl}/api/user/monitor/user-devices/${deviceId}/deactivate`,
  },
  channelPartner: {
    getChannelPartnerListing: `${goBaseUrl}/api/v1/sales/fetch-channel-partners`, // migrated to fusion-backend-go (ops/channel_partner)
    transferHandoverToChannelPartner: `${goBaseUrl}/api/v1/sales/transfer-handover-to-channel-partner`, // migrated to fusion-backend-go (ops/channel_partner)
    fetchContractsByChannelPartner: `${goBaseUrl}/api/v1/sales/fetch-contracts-by-channel-partner`, // migrated to fusion-backend-go (ops/channel_partner)
    invoiceVisibilityForChannelPartner: `${goBaseUrl}/api/v1/sales/invoice-visibility-for-channel-partner`, // migrated to fusion-backend-go (ops/channel_partner)
  },
  jms: {
    jmsPoDetails: `${baseUrl}/api/v2/jms/po-jms-details`,
    submitJmsDetails: `${baseUrl}/api/v2/jms/submit-jms-details`,
    approveJmsDetails: `${baseUrl}/api/v2/jms/approve-jms-details`,
    getJmsListing: `${baseUrl}/api/v2/jms/jms-list`,
  },
  dynamicContents: {
    list: `${goBaseUrl}/api/v1/dynamic-contents/list`, // migrated to fusion-backend-go
    view: `${goBaseUrl}/api/v1/dynamic-contents/view`, // migrated to fusion-backend-go
    add: `${goBaseUrl}/api/v1/dynamic-contents/add`, // migrated to fusion-backend-go
    edit: `${goBaseUrl}/api/v1/dynamic-contents/edit`, // migrated to fusion-backend-go
  },
  siteLeadReferral: {
    apiPath: siteLeadReferralApiPath,
    list: `${valetApiUrl}${siteLeadReferralApiPath}/list`,
    create: `${valetApiUrl}${siteLeadReferralApiPath}/create`,
    listSpoc: `${valetApiUrl}${siteLeadReferralApiPath}/list-spoc`,
    rejectReasons: `${valetApiUrl}${siteLeadReferralApiPath}/reject-reasons`,
    statusHistory: (id) =>
      `${valetApiUrl}${siteLeadReferralApiPath}/${id}/status-history`,
    assignSpoc: (id) =>
      `${valetApiUrl}${siteLeadReferralApiPath}/${id}/assign-spoc`,
    validate: (id) =>
      `${valetApiUrl}${siteLeadReferralApiPath}/${id}/validate`,
    reject: (id) =>
      `${valetApiUrl}${siteLeadReferralApiPath}/${id}/reject`,
    centralValidate: (id) =>
      `${valetApiUrl}${siteLeadReferralApiPath}/${id}/central-validate`,
    stage: (id) => `${valetApiUrl}${siteLeadReferralApiPath}/${id}/stage`,
  },
  vendorOnboarding: {
    createMeta: (firmName, name, email, tokenUserId) => {
      const base = `${baseUrl}/api/v2/procurement/vendor-onboarding/create-meta/${firmName}/${name}/${email}`;
      return tokenUserId ? `${base}/${tokenUserId}` : base;
    },
    editMeta: (vendorId) =>
      `${baseUrl}/api/v2/procurement/vendor-onboarding/edit/${vendorId}`,
    validateGst: (gstNo) =>
      `${baseUrl}/api/v2/procurement/vendor-onboarding/gst/${encodeURIComponent(gstNo)}`,
    submit: `${baseUrl}/api/v2/procurement/vendor-onboarding/submit`,
    update: `${baseUrl}/api/v2/procurement/vendor-onboarding/update`,
    fetchGeoCity: `${baseUrl}/api/v2/procurement/vendor-onboarding/geo/cities`,
    fetchGeoPincode: `${baseUrl}/api/v2/procurement/vendor-onboarding/geo/pincodes`,
    msmeDeclarationForm: `${baseUrl}/declaration_form/MSME_Declaration.pdf`,
  },
  darwinAttendance: {
    monthsFilter: `${goBaseUrl}/api/v1/darwin-work/get-months-filter`,
    monthlyAttendance: `${goBaseUrl}/api/v1/darwin-work/get-all-days`,
    dailyMeetings: `${goBaseUrl}/api/v1/darwin-work/meeting-data-for-particular-date`,
    createRegularization: `${goBaseUrl}/api/v1/darwin-work/save-attendance-regularization-request`,
    regularizationRequests: `${goBaseUrl}/api/v1/darwin-work/get-regularization-details`,
    regularizationFilter: `${goBaseUrl}/api/v1/darwin-work/get-regularization-filter`,
    regularizationDetails: `${goBaseUrl}/api/v1/darwin-work/get-regularization-details`,
    updateRegularization: `${goBaseUrl}/api/v1/darwin-work/update-attendance-regularization`,
  },
};

export default Config;
